const data = 
[
    {
        "brand": "Sony",
        "camera": "A1",
        "cameraSize": "α1   128.9×96.9×80.8mm  652g",
        "cameraLen": "E 10–18mm F4 OSS",
        "cameraLenSize": "Φ70mm*63.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A1",
        "cameraSize": "α1   128.9×96.9×80.8mm  652g",
        "cameraLen": "FE 12-24mm F4 G",
        "cameraLenSize": "Φ87mm*117mm  565g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A1",
        "cameraSize": "α1   128.9×96.9×80.8mm  652g",
        "cameraLen": "FE 16-35mm F2.8 GM",
        "cameraLenSize": "Φ89mm*122mm  680g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A1",
        "cameraSize": "α1   128.9×96.9×80.8mm  652g",
        "cameraLen": "FE16-35mm f/4 ZA OSS",
        "cameraLenSize": "Φ78mm*99mm   518g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A1",
        "cameraSize": "α1   128.9×96.9×80.8mm  652g",
        "cameraLen": "FE 24-70 F2.8 GM",
        "cameraLenSize": "Φ87.6mm*136mm  886g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A1",
        "cameraSize": "α1   128.9×96.9×80.8mm  652g",
        "cameraLen": "Zeiss E 16-70 F4 OSS",
        "cameraLenSize": "Φ66.6mm*75mm  308g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A1",
        "cameraSize": "α1   128.9×96.9×80.8mm  652g",
        "cameraLen": "E PZ 18–105mm F4 G OSS",
        "cameraLenSize": "Φ78mm*110mm  427g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A1",
        "cameraSize": "α1   128.9×96.9×80.8mm  652g",
        "cameraLen": "E PZ 18–200mm F3.5–6.3 OSS LE",
        "cameraLenSize": "Φ93.2mm*99mm  649g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A1",
        "cameraSize": "α1   128.9×96.9×80.8mm  652g",
        "cameraLen": "FE 4/24-105 G OSS",
        "cameraLenSize": "Φ83.4mm*113.3 mm  663g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A1",
        "cameraSize": "α1   128.9×96.9×80.8mm  652g",
        "cameraLen": "FE 28-70mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ72.5mm*83mm  295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A1",
        "cameraSize": "α1   128.9×96.9×80.8mm  652g",
        "cameraLen": "FE 28mm F2",
        "cameraLenSize": "Φ64mm*60mm  200g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A1",
        "cameraSize": "α1   128.9×96.9×80.8mm  652g",
        "cameraLen": "Zeiss FE 35mm F2.8 ZA",
        "cameraLenSize": "Φ61.5mm*36.5mm  120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A1",
        "cameraSize": "α1   128.9×96.9×80.8mm  652g",
        "cameraLen": "Sigma 30mm f/1.4 DC DN",
        "cameraLenSize": "Φ64.8mm*73.3mm  265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A1",
        "cameraSize": "α1   128.9×96.9×80.8mm  652g",
        "cameraLen": "Sigma 35mm f1.4 DG HSM Art",
        "cameraLenSize": "Φ77mm*94mm  665g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A1",
        "cameraSize": "α1   128.9×96.9×80.8mm  652g",
        "cameraLen": "FE 55mm F1.8",
        "cameraLenSize": "Φ64mm*71mm  281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A1",
        "cameraSize": "α1   128.9×96.9×80.8mm  652g",
        "cameraLen": "FE 50mm F2.8 MACRO",
        "cameraLenSize": "Φ71mm*71mm  236g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A1",
        "cameraSize": "α1   128.9×96.9×80.8mm  652g",
        "cameraLen": "FE 85mm F1.4 GM",
        "cameraLenSize": "Φ89.5mm*107.5mm  820g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A1",
        "cameraSize": "α1   128.9×96.9×80.8mm  652g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm  426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A1",
        "cameraSize": "α1   128.9×96.9×80.8mm  652g",
        "cameraLen": "FE PZ 16-35mm F4 G",
        "cameraLenSize": "Φ80.5mm*88.1mm  353g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is Required"
    },
    {
        "brand": "Sony",
        "camera": "A1",
        "cameraSize": "α1   128.9×96.9×80.8mm  652g",
        "cameraLen": "Sigma 65mm F2 DG DN",
        "cameraLenSize": "φ72mm*74.7mm  405g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9",
        "cameraSize": "α9    126.9×95.6×63.0mm  588g",
        "cameraLen": "E 10–18mm F4 OSS",
        "cameraLenSize": "Φ70mm*63.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A9",
        "cameraSize": "α9    126.9×95.6×63.0mm  588g",
        "cameraLen": "FE 12-24mm F4 G",
        "cameraLenSize": "Φ87mm*117mm  565g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9",
        "cameraSize": "α9    126.9×95.6×63.0mm  588g",
        "cameraLen": "FE 16-35mm F2.8 GM",
        "cameraLenSize": "Φ89mm*122mm  680g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9",
        "cameraSize": "α9    126.9×95.6×63.0mm  588g",
        "cameraLen": "FE16-35mm f/4 ZA OSS",
        "cameraLenSize": "Φ78mm*99mm   518g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9",
        "cameraSize": "α9    126.9×95.6×63.0mm  588g",
        "cameraLen": "FE 24-70 F2.8 GM",
        "cameraLenSize": "Φ87.6mm*136mm  886g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9",
        "cameraSize": "α9    126.9×95.6×63.0mm  588g",
        "cameraLen": "Zeiss E 16-70 F4 OSS",
        "cameraLenSize": "Φ66.6mm*75mm  308g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9",
        "cameraSize": "α9    126.9×95.6×63.0mm  588g",
        "cameraLen": "E PZ 18–105mm F4 G OSS",
        "cameraLenSize": "Φ78mm*110mm  427g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9",
        "cameraSize": "α9    126.9×95.6×63.0mm  588g",
        "cameraLen": "E PZ 18–200mm F3.5–6.3 OSS LE",
        "cameraLenSize": "Φ93.2mm*99mm  649g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9",
        "cameraSize": "α9    126.9×95.6×63.0mm  588g",
        "cameraLen": "FE 4/24-105 G OSS",
        "cameraLenSize": "Φ83.4mm*113.3 mm  663g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9",
        "cameraSize": "α9    126.9×95.6×63.0mm  588g",
        "cameraLen": "FE 28-70mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ72.5mm*83mm  295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A9",
        "cameraSize": "α9    126.9×95.6×63.0mm  588g",
        "cameraLen": "FE 28mm F2",
        "cameraLenSize": "Φ64mm*60mm  200g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A9",
        "cameraSize": "α9    126.9×95.6×63.0mm  588g",
        "cameraLen": "Zeiss FE 35mm F2.8 ZA",
        "cameraLenSize": "Φ61.5mm*36.5mm  120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A9",
        "cameraSize": "α9    126.9×95.6×63.0mm  588g",
        "cameraLen": "Sigma 30mm f/1.4 DC DN",
        "cameraLenSize": "Φ64.8mm*73.3mm  265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A9",
        "cameraSize": "α9    126.9×95.6×63.0mm  588g",
        "cameraLen": "Sigma 35mm f1.4 DG HSM Art",
        "cameraLenSize": "Φ77mm*94mm  665g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9",
        "cameraSize": "α9    126.9×95.6×63.0mm  588g",
        "cameraLen": "FE 55mm F1.8",
        "cameraLenSize": "Φ64mm*71mm  281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A9",
        "cameraSize": "α9    126.9×95.6×63.0mm  588g",
        "cameraLen": "FE 50mm F2.8 MACRO",
        "cameraLenSize": "Φ71mm*71mm  236g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A9",
        "cameraSize": "α9    126.9×95.6×63.0mm  588g",
        "cameraLen": "FE 85mm F1.4 GM",
        "cameraLenSize": "Φ89.5mm*107.5mm  820g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9",
        "cameraSize": "α9    126.9×95.6×63.0mm  588g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm  426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9",
        "cameraSize": "α9    126.9×95.6×63.0mm  588g",
        "cameraLen": "FE PZ 16-35mm F4 G",
        "cameraLenSize": "Φ80.5mm*88.1mm  353g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is Required"
    },
    {
        "brand": "Sony",
        "camera": "A9",
        "cameraSize": "α9    126.9×95.6×63.0mm  588g",
        "cameraLen": "Sigma 65mm F2 DG DN",
        "cameraLenSize": "φ72mm*74.7mm  405g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9 Ⅱ",
        "cameraSize": "α9 Ⅱ 128.9× 96.4×77.5mm  678g",
        "cameraLen": "E 10–18mm F4 OSS",
        "cameraLenSize": "Φ70mm*63.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A9 Ⅱ",
        "cameraSize": "α9 Ⅱ 128.9× 96.4×77.5mm  678g",
        "cameraLen": "FE 12-24mm F4 G",
        "cameraLenSize": "Φ87mm*117mm  565g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9 Ⅱ",
        "cameraSize": "α9 Ⅱ 128.9× 96.4×77.5mm  678g",
        "cameraLen": "FE 16-35mm F2.8 GM",
        "cameraLenSize": "Φ89mm*122mm  680g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9 Ⅱ",
        "cameraSize": "α9 Ⅱ 128.9× 96.4×77.5mm  678g",
        "cameraLen": "FE16-35mm f/4 ZA OSS",
        "cameraLenSize": "Φ78mm*99mm   518g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9 Ⅱ",
        "cameraSize": "α9 Ⅱ 128.9× 96.4×77.5mm  678g",
        "cameraLen": "FE 24-70 F2.8 GM",
        "cameraLenSize": "Φ87.6mm*136mm  886g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9 Ⅱ",
        "cameraSize": "α9 Ⅱ 128.9× 96.4×77.5mm  678g",
        "cameraLen": "Zeiss E 16-70 F4 OSS",
        "cameraLenSize": "Φ66.6mm*75mm  308g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9 Ⅱ",
        "cameraSize": "α9 Ⅱ 128.9× 96.4×77.5mm  678g",
        "cameraLen": "E PZ 18–105mm F4 G OSS",
        "cameraLenSize": "Φ78mm*110mm  427g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9 Ⅱ",
        "cameraSize": "α9 Ⅱ 128.9× 96.4×77.5mm  678g",
        "cameraLen": "E PZ 18–200mm F3.5–6.3 OSS LE",
        "cameraLenSize": "Φ93.2mm*99mm  649g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9 Ⅱ",
        "cameraSize": "α9 Ⅱ 128.9× 96.4×77.5mm  678g",
        "cameraLen": "FE 4/24-105 G OSS",
        "cameraLenSize": "Φ83.4mm*113.3 mm  663g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9 Ⅱ",
        "cameraSize": "α9 Ⅱ 128.9× 96.4×77.5mm  678g",
        "cameraLen": "FE 28-70mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ72.5mm*83mm  295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A9 Ⅱ",
        "cameraSize": "α9 Ⅱ 128.9× 96.4×77.5mm  678g",
        "cameraLen": "FE 28mm F2",
        "cameraLenSize": "Φ64mm*60mm  200g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A9 Ⅱ",
        "cameraSize": "α9 Ⅱ 128.9× 96.4×77.5mm  678g",
        "cameraLen": "Zeiss FE 35mm F2.8 ZA",
        "cameraLenSize": "Φ61.5mm*36.5mm  120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A9 Ⅱ",
        "cameraSize": "α9 Ⅱ 128.9× 96.4×77.5mm  678g",
        "cameraLen": "Sigma 30mm f/1.4 DC DN",
        "cameraLenSize": "Φ64.8mm*73.3mm  265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A9 Ⅱ",
        "cameraSize": "α9 Ⅱ 128.9× 96.4×77.5mm  678g",
        "cameraLen": "Sigma 35mm f1.4 DG HSM Art",
        "cameraLenSize": "Φ77mm*94mm  665g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9 Ⅱ",
        "cameraSize": "α9 Ⅱ 128.9× 96.4×77.5mm  678g",
        "cameraLen": "FE 55mm F1.8",
        "cameraLenSize": "Φ64mm*71mm  281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A9 Ⅱ",
        "cameraSize": "α9 Ⅱ 128.9× 96.4×77.5mm  678g",
        "cameraLen": "FE 50mm F2.8 MACRO",
        "cameraLenSize": "Φ71mm*71mm  236g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A9 Ⅱ",
        "cameraSize": "α9 Ⅱ 128.9× 96.4×77.5mm  678g",
        "cameraLen": "FE 85mm F1.4 GM",
        "cameraLenSize": "Φ89.5mm*107.5mm  820g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9 Ⅱ",
        "cameraSize": "α9 Ⅱ 128.9× 96.4×77.5mm  678g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm  426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A9 Ⅱ",
        "cameraSize": "α9 Ⅱ 128.9× 96.4×77.5mm  678g",
        "cameraLen": "FE PZ 16-35mm F4 G",
        "cameraLenSize": "Φ80.5mm*88.1mm  353g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is Required"
    },
    {
        "brand": "Sony",
        "camera": "A9 Ⅱ",
        "cameraSize": "α9 Ⅱ 128.9× 96.4×77.5mm  678g",
        "cameraLen": "Sigma 65mm F2 DG DN",
        "cameraLenSize": "φ72mm*74.7mm  405g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "α7M3  126.9×95.6×73.7mm  565g",
        "cameraLen": "E 10–18mm F4 OSS",
        "cameraLenSize": "Φ70mm*63.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "α7M3  126.9×95.6×73.7mm  565g",
        "cameraLen": "FE 12-24mm F4 G",
        "cameraLenSize": "Φ87mm*117mm  565g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "α7M3  126.9×95.6×73.7mm  565g",
        "cameraLen": "FE 16-35mm F2.8 GM",
        "cameraLenSize": "Φ89mm*122mm  680g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "α7M3  126.9×95.6×73.7mm  565g",
        "cameraLen": "FE16-35mm f/4 ZA OSS",
        "cameraLenSize": "Φ78mm*99mm   518g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "α7M3  126.9×95.6×73.7mm  565g",
        "cameraLen": "FE 24-70 F2.8 GM",
        "cameraLenSize": "Φ87.6mm*136mm  886g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "α7M3  126.9×95.6×73.7mm  565g",
        "cameraLen": "Zeiss E 16-70 F4 OSS",
        "cameraLenSize": "Φ66.6mm*75mm  308g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "α7M3  126.9×95.6×73.7mm  565g",
        "cameraLen": "E PZ 18–105mm F4 G OSS",
        "cameraLenSize": "Φ78mm*110mm  427g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "α7M3  126.9×95.6×73.7mm  565g",
        "cameraLen": "E PZ 18–200mm F3.5–6.3 OSS LE",
        "cameraLenSize": "Φ93.2mm*99mm  649g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "α7M3  126.9×95.6×73.7mm  565g",
        "cameraLen": "FE 4/24-105 G OSS",
        "cameraLenSize": "Φ83.4mm*113.3 mm  663g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "α7M3  126.9×95.6×73.7mm  565g",
        "cameraLen": "FE 28-70mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ72.5mm*83mm  295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "α7M3  126.9×95.6×73.7mm  565g",
        "cameraLen": "FE 28mm F2",
        "cameraLenSize": "Φ64mm*60mm  200g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "α7M3  126.9×95.6×73.7mm  565g",
        "cameraLen": "Zeiss FE 35mm F2.8 ZA",
        "cameraLenSize": "Φ61.5mm*36.5mm  120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "α7M3  126.9×95.6×73.7mm  565g",
        "cameraLen": "Sigma 30mm f/1.4 DC DN",
        "cameraLenSize": "Φ64.8mm*73.3mm  265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "α7M3  126.9×95.6×73.7mm  565g",
        "cameraLen": "Sigma 35mm f1.4 DG HSM Art",
        "cameraLenSize": "Φ77mm*94mm  665g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "α7M3  126.9×95.6×73.7mm  565g",
        "cameraLen": "FE 55mm F1.8",
        "cameraLenSize": "Φ64mm*71mm  281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "α7M3  126.9×95.6×73.7mm  565g",
        "cameraLen": "FE 50mm F2.8 MACRO",
        "cameraLenSize": "Φ71mm*71mm  236g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "α7M3  126.9×95.6×73.7mm  565g",
        "cameraLen": "FE 85mm F1.4 GM",
        "cameraLenSize": "Φ89.5mm*107.5mm  820g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "α7M3  126.9×95.6×73.7mm  565g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm  426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "α7M3  126.9×95.6×73.7mm  565g",
        "cameraLen": "FE PZ 16-35mm F4 G",
        "cameraLenSize": "Φ80.5mm*88.1mm  353g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is Required"
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅲ",
        "cameraSize": "α7M3  126.9×95.6×73.7mm  565g",
        "cameraLen": "Sigma 65mm F2 DG DN",
        "cameraLenSize": "φ72mm*74.7mm  405g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "α7R   126.9×94.4×48.2mm  407g",
        "cameraLen": "E 10–18mm F4 OSS",
        "cameraLenSize": "Φ70mm*63.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "α7R   126.9×94.4×48.2mm  407g",
        "cameraLen": "FE 12-24mm F4 G",
        "cameraLenSize": "Φ87mm*117mm  565g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "α7R   126.9×94.4×48.2mm  407g",
        "cameraLen": "FE 16-35mm F2.8 GM",
        "cameraLenSize": "Φ89mm*122mm  680g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "α7R   126.9×94.4×48.2mm  407g",
        "cameraLen": "FE16-35mm f/4 ZA OSS",
        "cameraLenSize": "Φ78mm*99mm   518g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "α7R   126.9×94.4×48.2mm  407g",
        "cameraLen": "FE 24-70 F2.8 GM",
        "cameraLenSize": "Φ87.6mm*136mm  886g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "α7R   126.9×94.4×48.2mm  407g",
        "cameraLen": "Zeiss E 16-70 F4 OSS",
        "cameraLenSize": "Φ66.6mm*75mm  308g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "α7R   126.9×94.4×48.2mm  407g",
        "cameraLen": "E PZ 18–105mm F4 G OSS",
        "cameraLenSize": "Φ78mm*110mm  427g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "α7R   126.9×94.4×48.2mm  407g",
        "cameraLen": "E PZ 18–200mm F3.5–6.3 OSS LE",
        "cameraLenSize": "Φ93.2mm*99mm  649g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "α7R   126.9×94.4×48.2mm  407g",
        "cameraLen": "FE 4/24-105 G OSS",
        "cameraLenSize": "Φ83.4mm*113.3 mm  663g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "α7R   126.9×94.4×48.2mm  407g",
        "cameraLen": "FE 28-70mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ72.5mm*83mm  295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "α7R   126.9×94.4×48.2mm  407g",
        "cameraLen": "FE 28mm F2",
        "cameraLenSize": "Φ64mm*60mm  200g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "α7R   126.9×94.4×48.2mm  407g",
        "cameraLen": "Zeiss FE 35mm F2.8 ZA",
        "cameraLenSize": "Φ61.5mm*36.5mm  120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "α7R   126.9×94.4×48.2mm  407g",
        "cameraLen": "Sigma 30mm f/1.4 DC DN",
        "cameraLenSize": "Φ64.8mm*73.3mm  265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "α7R   126.9×94.4×48.2mm  407g",
        "cameraLen": "Sigma 35mm f1.4 DG HSM Art",
        "cameraLenSize": "Φ77mm*94mm  665g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "α7R   126.9×94.4×48.2mm  407g",
        "cameraLen": "FE 55mm F1.8",
        "cameraLenSize": "Φ64mm*71mm  281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "α7R   126.9×94.4×48.2mm  407g",
        "cameraLen": "FE 50mm F2.8 MACRO",
        "cameraLenSize": "Φ71mm*71mm  236g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "α7R   126.9×94.4×48.2mm  407g",
        "cameraLen": "FE 85mm F1.4 GM",
        "cameraLenSize": "Φ89.5mm*107.5mm  820g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "α7R   126.9×94.4×48.2mm  407g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm  426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "α7R   126.9×94.4×48.2mm  407g",
        "cameraLen": "FE PZ 16-35mm F4 G",
        "cameraLenSize": "Φ80.5mm*88.1mm  353g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is Required"
    },
    {
        "brand": "Sony",
        "camera": "A7R",
        "cameraSize": "α7R   126.9×94.4×48.2mm  407g",
        "cameraLen": "Sigma 65mm F2 DG DN",
        "cameraLenSize": "φ72mm*74.7mm  405g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅲ",
        "cameraSize": "α7R Ⅲ   126.9×95.6×62.7mm  572g",
        "cameraLen": "E 10–18mm F4 OSS",
        "cameraLenSize": "Φ70mm*63.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅲ",
        "cameraSize": "α7R Ⅲ   126.9×95.6×62.7mm  572g",
        "cameraLen": "FE 12-24mm F4 G",
        "cameraLenSize": "Φ87mm*117mm  565g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅲ",
        "cameraSize": "α7R Ⅲ   126.9×95.6×62.7mm  572g",
        "cameraLen": "FE 16-35mm F2.8 GM",
        "cameraLenSize": "Φ89mm*122mm  680g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅲ",
        "cameraSize": "α7R Ⅲ   126.9×95.6×62.7mm  572g",
        "cameraLen": "FE16-35mm f/4 ZA OSS",
        "cameraLenSize": "Φ78mm*99mm   518g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅲ",
        "cameraSize": "α7R Ⅲ   126.9×95.6×62.7mm  572g",
        "cameraLen": "FE 24-70 F2.8 GM",
        "cameraLenSize": "Φ87.6mm*136mm  886g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅲ",
        "cameraSize": "α7R Ⅲ   126.9×95.6×62.7mm  572g",
        "cameraLen": "Zeiss E 16-70 F4 OSS",
        "cameraLenSize": "Φ66.6mm*75mm  308g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅲ",
        "cameraSize": "α7R Ⅲ   126.9×95.6×62.7mm  572g",
        "cameraLen": "E PZ 18–105mm F4 G OSS",
        "cameraLenSize": "Φ78mm*110mm  427g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅲ",
        "cameraSize": "α7R Ⅲ   126.9×95.6×62.7mm  572g",
        "cameraLen": "E PZ 18–200mm F3.5–6.3 OSS LE",
        "cameraLenSize": "Φ93.2mm*99mm  649g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅲ",
        "cameraSize": "α7R Ⅲ   126.9×95.6×62.7mm  572g",
        "cameraLen": "FE 4/24-105 G OSS",
        "cameraLenSize": "Φ83.4mm*113.3 mm  663g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅲ",
        "cameraSize": "α7R Ⅲ   126.9×95.6×62.7mm  572g",
        "cameraLen": "FE 28-70mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ72.5mm*83mm  295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅲ",
        "cameraSize": "α7R Ⅲ   126.9×95.6×62.7mm  572g",
        "cameraLen": "FE 28mm F2",
        "cameraLenSize": "Φ64mm*60mm  200g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅲ",
        "cameraSize": "α7R Ⅲ   126.9×95.6×62.7mm  572g",
        "cameraLen": "Zeiss FE 35mm F2.8 ZA",
        "cameraLenSize": "Φ61.5mm*36.5mm  120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅲ",
        "cameraSize": "α7R Ⅲ   126.9×95.6×62.7mm  572g",
        "cameraLen": "Sigma 30mm f/1.4 DC DN",
        "cameraLenSize": "Φ64.8mm*73.3mm  265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅲ",
        "cameraSize": "α7R Ⅲ   126.9×95.6×62.7mm  572g",
        "cameraLen": "Sigma 35mm f1.4 DG HSM Art",
        "cameraLenSize": "Φ77mm*94mm  665g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅲ",
        "cameraSize": "α7R Ⅲ   126.9×95.6×62.7mm  572g",
        "cameraLen": "FE 55mm F1.8",
        "cameraLenSize": "Φ64mm*71mm  281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅲ",
        "cameraSize": "α7R Ⅲ   126.9×95.6×62.7mm  572g",
        "cameraLen": "FE 50mm F2.8 MACRO",
        "cameraLenSize": "Φ71mm*71mm  236g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅲ",
        "cameraSize": "α7R Ⅲ   126.9×95.6×62.7mm  572g",
        "cameraLen": "FE 85mm F1.4 GM",
        "cameraLenSize": "Φ89.5mm*107.5mm  820g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅲ",
        "cameraSize": "α7R Ⅲ   126.9×95.6×62.7mm  572g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm  426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅲ",
        "cameraSize": "α7R Ⅲ   126.9×95.6×62.7mm  572g",
        "cameraLen": "FE PZ 16-35mm F4 G",
        "cameraLenSize": "Φ80.5mm*88.1mm  353g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is Required"
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅲ",
        "cameraSize": "α7R Ⅲ   126.9×95.6×62.7mm  572g",
        "cameraLen": "Sigma 65mm F2 DG DN",
        "cameraLenSize": "φ72mm*74.7mm  405g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "α7S    126.9×94.4×48.2mm  446g",
        "cameraLen": "E 10–18mm F4 OSS",
        "cameraLenSize": "Φ70mm*63.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "α7S    126.9×94.4×48.2mm  446g",
        "cameraLen": "FE 12-24mm F4 G",
        "cameraLenSize": "Φ87mm*117mm  565g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "α7S    126.9×94.4×48.2mm  446g",
        "cameraLen": "FE 16-35mm F2.8 GM",
        "cameraLenSize": "Φ89mm*122mm  680g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "α7S    126.9×94.4×48.2mm  446g",
        "cameraLen": "FE16-35mm f/4 ZA OSS",
        "cameraLenSize": "Φ78mm*99mm   518g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "α7S    126.9×94.4×48.2mm  446g",
        "cameraLen": "FE 24-70 F2.8 GM",
        "cameraLenSize": "Φ87.6mm*136mm  886g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "α7S    126.9×94.4×48.2mm  446g",
        "cameraLen": "Zeiss E 16-70 F4 OSS",
        "cameraLenSize": "Φ66.6mm*75mm  308g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "α7S    126.9×94.4×48.2mm  446g",
        "cameraLen": "E PZ 18–105mm F4 G OSS",
        "cameraLenSize": "Φ78mm*110mm  427g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "α7S    126.9×94.4×48.2mm  446g",
        "cameraLen": "E PZ 18–200mm F3.5–6.3 OSS LE",
        "cameraLenSize": "Φ93.2mm*99mm  649g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "α7S    126.9×94.4×48.2mm  446g",
        "cameraLen": "FE 4/24-105 G OSS",
        "cameraLenSize": "Φ83.4mm*113.3 mm  663g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "α7S    126.9×94.4×48.2mm  446g",
        "cameraLen": "FE 28-70mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ72.5mm*83mm  295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "α7S    126.9×94.4×48.2mm  446g",
        "cameraLen": "FE 28mm F2",
        "cameraLenSize": "Φ64mm*60mm  200g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "α7S    126.9×94.4×48.2mm  446g",
        "cameraLen": "Zeiss FE 35mm F2.8 ZA",
        "cameraLenSize": "Φ61.5mm*36.5mm  120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "α7S    126.9×94.4×48.2mm  446g",
        "cameraLen": "Sigma 30mm f/1.4 DC DN",
        "cameraLenSize": "Φ64.8mm*73.3mm  265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "α7S    126.9×94.4×48.2mm  446g",
        "cameraLen": "Sigma 35mm f1.4 DG HSM Art",
        "cameraLenSize": "Φ77mm*94mm  665g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "α7S    126.9×94.4×48.2mm  446g",
        "cameraLen": "FE 55mm F1.8",
        "cameraLenSize": "Φ64mm*71mm  281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "α7S    126.9×94.4×48.2mm  446g",
        "cameraLen": "FE 50mm F2.8 MACRO",
        "cameraLenSize": "Φ71mm*71mm  236g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "α7S    126.9×94.4×48.2mm  446g",
        "cameraLen": "FE 85mm F1.4 GM",
        "cameraLenSize": "Φ89.5mm*107.5mm  820g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "α7S    126.9×94.4×48.2mm  446g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm  426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "α7S    126.9×94.4×48.2mm  446g",
        "cameraLen": "FE PZ 16-35mm F4 G",
        "cameraLenSize": "Φ80.5mm*88.1mm  353g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is Required"
    },
    {
        "brand": "Sony",
        "camera": "A7S",
        "cameraSize": "α7S    126.9×94.4×48.2mm  446g",
        "cameraLen": "Sigma 65mm F2 DG DN",
        "cameraLenSize": "φ72mm*74.7mm  405g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "α7S Ⅱ  126.9×95.7×60.3mm  584g",
        "cameraLen": "E 10–18mm F4 OSS",
        "cameraLenSize": "Φ70mm*63.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "α7S Ⅱ  126.9×95.7×60.3mm  584g",
        "cameraLen": "FE 12-24mm F4 G",
        "cameraLenSize": "Φ87mm*117mm  565g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "α7S Ⅱ  126.9×95.7×60.3mm  584g",
        "cameraLen": "FE 16-35mm F2.8 GM",
        "cameraLenSize": "Φ89mm*122mm  680g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "α7S Ⅱ  126.9×95.7×60.3mm  584g",
        "cameraLen": "FE16-35mm f/4 ZA OSS",
        "cameraLenSize": "Φ78mm*99mm   518g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "α7S Ⅱ  126.9×95.7×60.3mm  584g",
        "cameraLen": "FE 24-70 F2.8 GM",
        "cameraLenSize": "Φ87.6mm*136mm  886g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "α7S Ⅱ  126.9×95.7×60.3mm  584g",
        "cameraLen": "Zeiss E 16-70 F4 OSS",
        "cameraLenSize": "Φ66.6mm*75mm  308g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "α7S Ⅱ  126.9×95.7×60.3mm  584g",
        "cameraLen": "E PZ 18–105mm F4 G OSS",
        "cameraLenSize": "Φ78mm*110mm  427g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "α7S Ⅱ  126.9×95.7×60.3mm  584g",
        "cameraLen": "E PZ 18–200mm F3.5–6.3 OSS LE",
        "cameraLenSize": "Φ93.2mm*99mm  649g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "α7S Ⅱ  126.9×95.7×60.3mm  584g",
        "cameraLen": "FE 4/24-105 G OSS",
        "cameraLenSize": "Φ83.4mm*113.3 mm  663g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "α7S Ⅱ  126.9×95.7×60.3mm  584g",
        "cameraLen": "FE 28-70mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ72.5mm*83mm  295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "α7S Ⅱ  126.9×95.7×60.3mm  584g",
        "cameraLen": "FE 28mm F2",
        "cameraLenSize": "Φ64mm*60mm  200g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "α7S Ⅱ  126.9×95.7×60.3mm  584g",
        "cameraLen": "Zeiss FE 35mm F2.8 ZA",
        "cameraLenSize": "Φ61.5mm*36.5mm  120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "α7S Ⅱ  126.9×95.7×60.3mm  584g",
        "cameraLen": "Sigma 30mm f/1.4 DC DN",
        "cameraLenSize": "Φ64.8mm*73.3mm  265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "α7S Ⅱ  126.9×95.7×60.3mm  584g",
        "cameraLen": "Sigma 35mm f1.4 DG HSM Art",
        "cameraLenSize": "Φ77mm*94mm  665g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "α7S Ⅱ  126.9×95.7×60.3mm  584g",
        "cameraLen": "FE 55mm F1.8",
        "cameraLenSize": "Φ64mm*71mm  281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "α7S Ⅱ  126.9×95.7×60.3mm  584g",
        "cameraLen": "FE 50mm F2.8 MACRO",
        "cameraLenSize": "Φ71mm*71mm  236g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "α7S Ⅱ  126.9×95.7×60.3mm  584g",
        "cameraLen": "FE 85mm F1.4 GM",
        "cameraLenSize": "Φ89.5mm*107.5mm  820g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "α7S Ⅱ  126.9×95.7×60.3mm  584g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm  426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "α7S Ⅱ  126.9×95.7×60.3mm  584g",
        "cameraLen": "FE PZ 16-35mm F4 G",
        "cameraLenSize": "Φ80.5mm*88.1mm  353g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is Required"
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅱ",
        "cameraSize": "α7S Ⅱ  126.9×95.7×60.3mm  584g",
        "cameraLen": "Sigma 65mm F2 DG DN",
        "cameraLenSize": "φ72mm*74.7mm  405g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "cameraSize": "α7S Ⅲ 128.9 x 96.9 x 80.8mm 614g",
        "cameraLen": "E 10–18mm F4 OSS",
        "cameraLenSize": "Φ70mm*63.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "cameraSize": "α7S Ⅲ 128.9 x 96.9 x 80.8mm 614g",
        "cameraLen": "FE 12-24mm F4 G",
        "cameraLenSize": "Φ87mm*117mm  565g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "cameraSize": "α7S Ⅲ 128.9 x 96.9 x 80.8mm 614g",
        "cameraLen": "FE 16-35mm F2.8 GM",
        "cameraLenSize": "Φ89mm*122mm  680g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "cameraSize": "α7S Ⅲ 128.9 x 96.9 x 80.8mm 614g",
        "cameraLen": "FE16-35mm f/4 ZA OSS",
        "cameraLenSize": "Φ78mm*99mm   518g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "cameraSize": "α7S Ⅲ 128.9 x 96.9 x 80.8mm 614g",
        "cameraLen": "FE 24-70 F2.8 GM",
        "cameraLenSize": "Φ87.6mm*136mm  886g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "cameraSize": "α7S Ⅲ 128.9 x 96.9 x 80.8mm 614g",
        "cameraLen": "Zeiss E 16-70 F4 OSS",
        "cameraLenSize": "Φ66.6mm*75mm  308g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "cameraSize": "α7S Ⅲ 128.9 x 96.9 x 80.8mm 614g",
        "cameraLen": "E PZ 18–105mm F4 G OSS",
        "cameraLenSize": "Φ78mm*110mm  427g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "cameraSize": "α7S Ⅲ 128.9 x 96.9 x 80.8mm 614g",
        "cameraLen": "E PZ 18–200mm F3.5–6.3 OSS LE",
        "cameraLenSize": "Φ93.2mm*99mm  649g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "cameraSize": "α7S Ⅲ 128.9 x 96.9 x 80.8mm 614g",
        "cameraLen": "FE 4/24-105 G OSS",
        "cameraLenSize": "Φ83.4mm*113.3 mm  663g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "cameraSize": "α7S Ⅲ 128.9 x 96.9 x 80.8mm 614g",
        "cameraLen": "FE 28-70mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ72.5mm*83mm  295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "cameraSize": "α7S Ⅲ 128.9 x 96.9 x 80.8mm 614g",
        "cameraLen": "FE 28mm F2",
        "cameraLenSize": "Φ64mm*60mm  200g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "cameraSize": "α7S Ⅲ 128.9 x 96.9 x 80.8mm 614g",
        "cameraLen": "Zeiss FE 35mm F2.8 ZA",
        "cameraLenSize": "Φ61.5mm*36.5mm  120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "cameraSize": "α7S Ⅲ 128.9 x 96.9 x 80.8mm 614g",
        "cameraLen": "Sigma 30mm f/1.4 DC DN",
        "cameraLenSize": "Φ64.8mm*73.3mm  265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "cameraSize": "α7S Ⅲ 128.9 x 96.9 x 80.8mm 614g",
        "cameraLen": "Sigma 35mm f1.4 DG HSM Art",
        "cameraLenSize": "Φ77mm*94mm  665g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "cameraSize": "α7S Ⅲ 128.9 x 96.9 x 80.8mm 614g",
        "cameraLen": "FE 55mm F1.8",
        "cameraLenSize": "Φ64mm*71mm  281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "cameraSize": "α7S Ⅲ 128.9 x 96.9 x 80.8mm 614g",
        "cameraLen": "FE 50mm F2.8 MACRO",
        "cameraLenSize": "Φ71mm*71mm  236g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "cameraSize": "α7S Ⅲ 128.9 x 96.9 x 80.8mm 614g",
        "cameraLen": "FE 85mm F1.4 GM",
        "cameraLenSize": "Φ89.5mm*107.5mm  820g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "cameraSize": "α7S Ⅲ 128.9 x 96.9 x 80.8mm 614g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm  426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "cameraSize": "α7S Ⅲ 128.9 x 96.9 x 80.8mm 614g",
        "cameraLen": "FE PZ 16-35mm F4 G",
        "cameraLenSize": "Φ80.5mm*88.1mm  353g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is Required"
    },
    {
        "brand": "Sony",
        "camera": "A7S Ⅲ",
        "cameraSize": "α7S Ⅲ 128.9 x 96.9 x 80.8mm 614g",
        "cameraLen": "Sigma 65mm F2 DG DN",
        "cameraLenSize": "φ72mm*74.7mm  405g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "α7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "E 10–18mm F4 OSS",
        "cameraLenSize": "Φ70mm*63.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "α7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "FE 12-24mm F4 G",
        "cameraLenSize": "Φ87mm*117mm  565g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "α7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "FE 16-35mm F2.8 GM",
        "cameraLenSize": "Φ89mm*122mm  680g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "α7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "FE16-35mm f/4 ZA OSS",
        "cameraLenSize": "Φ78mm*99mm   518g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "α7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "FE 24-70 F2.8 GM",
        "cameraLenSize": "Φ87.6mm*136mm  886g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "α7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "Zeiss E 16-70 F4 OSS",
        "cameraLenSize": "Φ66.6mm*75mm  308g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "α7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "E PZ 18–105mm F4 G OSS",
        "cameraLenSize": "Φ78mm*110mm  427g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "α7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "E PZ 18–200mm F3.5–6.3 OSS LE",
        "cameraLenSize": "Φ93.2mm*99mm  649g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "α7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "FE 4/24-105 G OSS",
        "cameraLenSize": "Φ83.4mm*113.3 mm  663g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "α7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "FE 28-70mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ72.5mm*83mm  295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "α7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "FE 28mm F2",
        "cameraLenSize": "Φ64mm*60mm  200g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "α7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "Zeiss FE 35mm F2.8 ZA",
        "cameraLenSize": "Φ61.5mm*36.5mm  120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "α7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "Sigma 30mm f/1.4 DC DN",
        "cameraLenSize": "Φ64.8mm*73.3mm  265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "α7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "Sigma 35mm f1.4 DG HSM Art",
        "cameraLenSize": "Φ77mm*94mm  665g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "α7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "FE 55mm F1.8",
        "cameraLenSize": "Φ64mm*71mm  281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "α7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "FE 50mm F2.8 MACRO",
        "cameraLenSize": "Φ71mm*71mm  236g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "α7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "FE 85mm F1.4 GM",
        "cameraLenSize": "Φ89.5mm*107.5mm  820g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "α7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm  426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "α7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "FE PZ 16-35mm F4 G",
        "cameraLenSize": "Φ80.5mm*88.1mm  353g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is Required"
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅱ",
        "cameraSize": "α7R2  126.9×95.7×60.3mm  582g",
        "cameraLen": "Sigma 65mm F2 DG DN",
        "cameraLenSize": "φ72mm*74.7mm  405g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "α7M2  126.9×95.7×59.7mm  556g",
        "cameraLen": "E 10–18mm F4 OSS",
        "cameraLenSize": "Φ70mm*63.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "α7M2  126.9×95.7×59.7mm  556g",
        "cameraLen": "FE 12-24mm F4 G",
        "cameraLenSize": "Φ87mm*117mm  565g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "α7M2  126.9×95.7×59.7mm  556g",
        "cameraLen": "FE 16-35mm F2.8 GM",
        "cameraLenSize": "Φ89mm*122mm  680g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "α7M2  126.9×95.7×59.7mm  556g",
        "cameraLen": "FE16-35mm f/4 ZA OSS",
        "cameraLenSize": "Φ78mm*99mm   518g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "α7M2  126.9×95.7×59.7mm  556g",
        "cameraLen": "FE 24-70 F2.8 GM",
        "cameraLenSize": "Φ87.6mm*136mm  886g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "α7M2  126.9×95.7×59.7mm  556g",
        "cameraLen": "Zeiss E 16-70 F4 OSS",
        "cameraLenSize": "Φ66.6mm*75mm  308g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "α7M2  126.9×95.7×59.7mm  556g",
        "cameraLen": "E PZ 18–105mm F4 G OSS",
        "cameraLenSize": "Φ78mm*110mm  427g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "α7M2  126.9×95.7×59.7mm  556g",
        "cameraLen": "E PZ 18–200mm F3.5–6.3 OSS LE",
        "cameraLenSize": "Φ93.2mm*99mm  649g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "α7M2  126.9×95.7×59.7mm  556g",
        "cameraLen": "FE 4/24-105 G OSS",
        "cameraLenSize": "Φ83.4mm*113.3 mm  663g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "α7M2  126.9×95.7×59.7mm  556g",
        "cameraLen": "FE 28-70mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ72.5mm*83mm  295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "α7M2  126.9×95.7×59.7mm  556g",
        "cameraLen": "FE 28mm F2",
        "cameraLenSize": "Φ64mm*60mm  200g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "α7M2  126.9×95.7×59.7mm  556g",
        "cameraLen": "Zeiss FE 35mm F2.8 ZA",
        "cameraLenSize": "Φ61.5mm*36.5mm  120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "α7M2  126.9×95.7×59.7mm  556g",
        "cameraLen": "Sigma 30mm f/1.4 DC DN",
        "cameraLenSize": "Φ64.8mm*73.3mm  265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "α7M2  126.9×95.7×59.7mm  556g",
        "cameraLen": "Sigma 35mm f1.4 DG HSM Art",
        "cameraLenSize": "Φ77mm*94mm  665g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "α7M2  126.9×95.7×59.7mm  556g",
        "cameraLen": "FE 55mm F1.8",
        "cameraLenSize": "Φ64mm*71mm  281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "α7M2  126.9×95.7×59.7mm  556g",
        "cameraLen": "FE 50mm F2.8 MACRO",
        "cameraLenSize": "Φ71mm*71mm  236g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "α7M2  126.9×95.7×59.7mm  556g",
        "cameraLen": "FE 85mm F1.4 GM",
        "cameraLenSize": "Φ89.5mm*107.5mm  820g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "α7M2  126.9×95.7×59.7mm  556g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm  426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "α7M2  126.9×95.7×59.7mm  556g",
        "cameraLen": "FE PZ 16-35mm F4 G",
        "cameraLenSize": "Φ80.5mm*88.1mm  353g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is Required"
    },
    {
        "brand": "Sony",
        "camera": "A7 Ⅱ",
        "cameraSize": "α7M2  126.9×95.7×59.7mm  556g",
        "cameraLen": "Sigma 65mm F2 DG DN",
        "cameraLenSize": "φ72mm*74.7mm  405g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "FX3",
        "cameraSize": "FX3：77.8×129.7×84.5mm 640g",
        "cameraLen": "TAMRON 28-75mm f/2.8 Di III RXD",
        "cameraLenSize": "Φ73.0mm*117.8mm  550g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is Required"
    },
    {
        "brand": "Sony",
        "camera": "A7 IV",
        "cameraSize": "α7M4 129.0×97.0×81.0mm  699g",
        "cameraLen": "FE 24-240mm F3.5-6.3 OSS",
        "cameraLenSize": "Φ119*81mm  780g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7 IV",
        "cameraSize": "α7M4 129.0×97.0×81.0mm  699g",
        "cameraLen": "FE 50mm f/1.8",
        "cameraLenSize": "Φ68.6mm*59.5mm  186g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅳ",
        "cameraSize": "A7R4  128.9×96.4×77.5mm  665g",
        "cameraLen": "FE 24-105mm f/4 G OSS",
        "cameraLenSize": "Φ83.4*113.3mm  663g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required and lens holder are required for Long end lens."
    },
    {
        "brand": "Sony",
        "camera": "A7R Ⅳ",
        "cameraSize": "A7R4  128.9×96.4×77.5mm  665g",
        "cameraLen": "FE 28-60mm f/4-5.6",
        "cameraLenSize": "Φ67mm*45mm  167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A7R ⅣA",
        "cameraSize": "A7RM4A 128.9×96.4×77.5mm  580g",
        "cameraLen": "FE 24-105mm f/4 G OSS",
        "cameraLenSize": "Φ83.4*113.3mm  663g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required and lens holder are required for Long end lens."
    },
    {
        "brand": "Sony",
        "camera": "A7R ⅣA",
        "cameraSize": "A7RM4A 128.9×96.4×77.5mm  580g",
        "cameraLen": "FE 28-60mm f/4-5.6",
        "cameraLenSize": "Φ67mm*45mm  167g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "DSC-RX10 IV",
        "cameraSize": "RX10M4  132.5×94×127.4mm 1095g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "1.Camera Riser required when you install horizontally and the Long end Lens need Lens holder;\n2.In vertical installation, it is best to add a quick release plate in horizontal installation and install the lens holder"
    },
    {
        "brand": "Sony",
        "camera": "FDR-AX60",
        "cameraSize": "FDR-AX60  73mm x 80.5mm x 173mm  535g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "FDR-AX700",
        "cameraSize": "FDR-AX700  116×89.5×196.5mm  935g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "E 10–18mm F4 OSS",
        "cameraLenSize": "Φ70mm*63.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "FE 12-24mm F4 G",
        "cameraLenSize": "Φ87mm*117mm  565g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "FE 16-35mm F2.8 GM",
        "cameraLenSize": "Φ89mm*122mm  680g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "FE16-35mm f/4 ZA OSS",
        "cameraLenSize": "Φ78mm*99mm   518g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "FE 24-70 F2.8 GM",
        "cameraLenSize": "Φ87.6mm*136mm  886g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm 426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "Zeiss E 16-70 F4 OSS",
        "cameraLenSize": "Φ66.6mm*75mm  308g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "E PZ 18–105mm F4 G OSS",
        "cameraLenSize": "Φ78mm*110mm  427g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "E PZ 18–200mm F3.5–6.3 OSS LE",
        "cameraLenSize": "Φ93.2mm*99mm  649g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "FE 4/24-105 G OSS",
        "cameraLenSize": "Φ83.4mm*113.3 mm  663g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "FE 28-70mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ72.5mm*83mm  295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "FE 28mm F2",
        "cameraLenSize": "Φ64mm*60mm  200g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "Zeiss FE 35mm F2.8 ZA",
        "cameraLenSize": "Φ61.5mm*36.5mm  120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "Sigma 30mm f/1.4 DC DN",
        "cameraLenSize": "Φ64.8mm*73.3mm  265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "Sigma 35mm f1.4 DG HSM Art",
        "cameraLenSize": "Φ77mm*94mm  665g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "FE 55mm F1.8",
        "cameraLenSize": "Φ64mm*71mm  281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "FE 50mm F2.8 MACRO",
        "cameraLenSize": "Φ71mm*71mm  236g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "FE 28-70mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ72.5mm*83mm 295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "FE 85mm F1.4 GM",
        "cameraLenSize": "Φ89.5mm*107.5mm  820g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "E 18-135mm F3.5-5.6 OSS",
        "cameraLenSize": "Φ67.2mm*88mm  325g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6000",
        "cameraSize": "α6000 120×66.9×45.1mm,285g",
        "cameraLen": "E PZ 16-50mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ64.7mm*29.9mm  116g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "E 10–18mm F4 OSS",
        "cameraLenSize": "Φ70mm*63.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "FE 12-24mm F4 G",
        "cameraLenSize": "Φ87mm*117mm  565g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "FE 16-35mm F2.8 GM",
        "cameraLenSize": "Φ89mm*122mm  680g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "FE16-35mm f/4 ZA OSS",
        "cameraLenSize": "Φ78mm*99mm   518g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "FE 24-70 F2.8 GM",
        "cameraLenSize": "Φ87.6mm*136mm  886g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm 426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "Zeiss E 16-70 F4 OSS",
        "cameraLenSize": "Φ66.6mm*75mm  308g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "E PZ 18–105mm F4 G OSS",
        "cameraLenSize": "Φ78mm*110mm  427g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "E PZ 18–200mm F3.5–6.3 OSS LE",
        "cameraLenSize": "Φ93.2mm*99mm  649g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "FE 4/24-105 G OSS",
        "cameraLenSize": "Φ83.4mm*113.3 mm  663g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "FE 28-70mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ72.5mm*83mm  295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "FE 28mm F2",
        "cameraLenSize": "Φ64mm*60mm  200g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "Zeiss FE 35mm F2.8 ZA",
        "cameraLenSize": "Φ61.5mm*36.5mm  120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "Sigma 30mm f/1.4 DC DN",
        "cameraLenSize": "Φ64.8mm*73.3mm  265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "Sigma 35mm f1.4 DG HSM Art",
        "cameraLenSize": "Φ77mm*94mm  665g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "FE 55mm F1.8",
        "cameraLenSize": "Φ64mm*71mm  281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "FE 50mm F2.8 MACRO",
        "cameraLenSize": "Φ71mm*71mm  236g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "FE 28-70mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ72.5mm*83mm 295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "FE 85mm F1.4 GM",
        "cameraLenSize": "Φ89.5mm*107.5mm  820g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "E 18-135mm F3.5-5.6 OSS",
        "cameraLenSize": "Φ67.2mm*88mm  325g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6100",
        "cameraSize": "α6100 120×66.9×49.9mm,396g",
        "cameraLen": "E PZ 16-50mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ64.7mm*29.9mm  116g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "E 10–18mm F4 OSS",
        "cameraLenSize": "Φ70mm*63.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "FE 12-24mm F4 G",
        "cameraLenSize": "Φ87mm*117mm  565g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "FE 16-35mm F2.8 GM",
        "cameraLenSize": "Φ89mm*122mm  680g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "FE16-35mm f/4 ZA OSS",
        "cameraLenSize": "Φ78mm*99mm   518g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "FE 24-70 F2.8 GM",
        "cameraLenSize": "Φ87.6mm*136mm  886g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm 426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "Zeiss E 16-70 F4 OSS",
        "cameraLenSize": "Φ66.6mm*75mm  308g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "E PZ 18–105mm F4 G OSS",
        "cameraLenSize": "Φ78mm*110mm  427g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "E PZ 18–200mm F3.5–6.3 OSS LE",
        "cameraLenSize": "Φ93.2mm*99mm  649g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "FE 4/24-105 G OSS",
        "cameraLenSize": "Φ83.4mm*113.3 mm  663g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "FE 28-70mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ72.5mm*83mm  295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "FE 28mm F2",
        "cameraLenSize": "Φ64mm*60mm  200g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "Zeiss FE 35mm F2.8 ZA",
        "cameraLenSize": "Φ61.5mm*36.5mm  120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "Sigma 30mm f/1.4 DC DN",
        "cameraLenSize": "Φ64.8mm*73.3mm  265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "Sigma 35mm f1.4 DG HSM Art",
        "cameraLenSize": "Φ77mm*94mm  665g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "FE 55mm F1.8",
        "cameraLenSize": "Φ64mm*71mm  281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "FE 50mm F2.8 MACRO",
        "cameraLenSize": "Φ71mm*71mm  236g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "FE 28-70mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ72.5mm*83mm 295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "FE 85mm F1.4 GM",
        "cameraLenSize": "Φ89.5mm*107.5mm  820g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "E 18-135mm F3.5-5.6 OSS",
        "cameraLenSize": "Φ67.2mm*88mm  325g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6300",
        "cameraSize": "α6300 120×66.9×48.8mm,361g",
        "cameraLen": "E PZ 16-50mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ64.7mm*29.9mm  116g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "E 10–18mm F4 OSS",
        "cameraLenSize": "Φ70mm*63.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "FE 12-24mm F4 G",
        "cameraLenSize": "Φ87mm*117mm  565g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "FE 16-35mm F2.8 GM",
        "cameraLenSize": "Φ89mm*122mm  680g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "FE16-35mm f/4 ZA OSS",
        "cameraLenSize": "Φ78mm*99mm   518g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "FE 24-70 F2.8 GM",
        "cameraLenSize": "Φ87.6mm*136mm  886g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm 426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "Zeiss E 16-70 F4 OSS",
        "cameraLenSize": "Φ66.6mm*75mm  308g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "E PZ 18–105mm F4 G OSS",
        "cameraLenSize": "Φ78mm*110mm  427g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "E PZ 18–200mm F3.5–6.3 OSS LE",
        "cameraLenSize": "Φ93.2mm*99mm  649g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "FE 4/24-105 G OSS",
        "cameraLenSize": "Φ83.4mm*113.3 mm  663g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "FE 28-70mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ72.5mm*83mm  295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "FE 28mm F2",
        "cameraLenSize": "Φ64mm*60mm  200g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "Zeiss FE 35mm F2.8 ZA",
        "cameraLenSize": "Φ61.5mm*36.5mm  120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "Sigma 30mm f/1.4 DC DN",
        "cameraLenSize": "Φ64.8mm*73.3mm  265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "Sigma 35mm f1.4 DG HSM Art",
        "cameraLenSize": "Φ77mm*94mm  665g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "FE 55mm F1.8",
        "cameraLenSize": "Φ64mm*71mm  281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "FE 50mm F2.8 MACRO",
        "cameraLenSize": "Φ71mm*71mm  236g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "FE 28-70mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ72.5mm*83mm 295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "FE 85mm F1.4 GM",
        "cameraLenSize": "Φ89.5mm*107.5mm  820g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "E 18-135mm F3.5-5.6 OSS",
        "cameraLenSize": "Φ67.2mm*88mm  325g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6400",
        "cameraSize": "α6400 120×67×60mm,359g",
        "cameraLen": "E PZ 16-50mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ64.7mm*29.9mm  116g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "E 10–18mm F4 OSS",
        "cameraLenSize": "Φ70mm*63.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "FE 12-24mm F4 G",
        "cameraLenSize": "Φ87mm*117mm  565g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "FE 16-35mm F2.8 GM",
        "cameraLenSize": "Φ89mm*122mm  680g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "FE16-35mm f/4 ZA OSS",
        "cameraLenSize": "Φ78mm*99mm   518g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "FE 24-70 F2.8 GM",
        "cameraLenSize": "Φ87.6mm*136mm  886g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm 426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "Zeiss E 16-70 F4 OSS",
        "cameraLenSize": "Φ66.6mm*75mm  308g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "E PZ 18–105mm F4 G OSS",
        "cameraLenSize": "Φ78mm*110mm  427g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "E PZ 18–200mm F3.5–6.3 OSS LE",
        "cameraLenSize": "Φ93.2mm*99mm  649g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "FE 4/24-105 G OSS",
        "cameraLenSize": "Φ83.4mm*113.3 mm  663g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "FE 28-70mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ72.5mm*83mm  295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "FE 28mm F2",
        "cameraLenSize": "Φ64mm*60mm  200g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "Zeiss FE 35mm F2.8 ZA",
        "cameraLenSize": "Φ61.5mm*36.5mm  120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "Sigma 30mm f/1.4 DC DN",
        "cameraLenSize": "Φ64.8mm*73.3mm  265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "Sigma 35mm f1.4 DG HSM Art",
        "cameraLenSize": "Φ77mm*94mm  665g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "FE 55mm F1.8",
        "cameraLenSize": "Φ64mm*71mm  281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "FE 50mm F2.8 MACRO",
        "cameraLenSize": "Φ71mm*71mm  236g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "FE 28-70mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ72.5mm*83mm 295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "FE 85mm F1.4 GM",
        "cameraLenSize": "Φ89.5mm*107.5mm  820g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "E 18-135mm F3.5-5.6 OSS",
        "cameraLenSize": "Φ67.2mm*88mm  325g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6500",
        "cameraSize": "α6500 120×66.9×53.3mm,410g",
        "cameraLen": "E PZ 16-50mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ64.7mm*29.9mm  116g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "E 10–18mm F4 OSS",
        "cameraLenSize": "Φ70mm*63.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "FE 12-24mm F4 G",
        "cameraLenSize": "Φ87mm*117mm  565g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "FE 16-35mm F2.8 GM",
        "cameraLenSize": "Φ89mm*122mm  680g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "FE16-35mm f/4 ZA OSS",
        "cameraLenSize": "Φ78mm*99mm   518g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "FE 24-70 F2.8 GM",
        "cameraLenSize": "Φ87.6mm*136mm  886g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "Vario-Tessar FE 24-70mm F4 ZA OSS",
        "cameraLenSize": "Φ73mm*94.5mm 426g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "Zeiss E 16-70 F4 OSS",
        "cameraLenSize": "Φ66.6mm*75mm  308g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "E PZ 18–105mm F4 G OSS",
        "cameraLenSize": "Φ78mm*110mm  427g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "E PZ 18–200mm F3.5–6.3 OSS LE",
        "cameraLenSize": "Φ93.2mm*99mm  649g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "FE 4/24-105 G OSS",
        "cameraLenSize": "Φ83.4mm*113.3 mm  663g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "FE 28-70mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ72.5mm*83mm  295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "FE 28mm F2",
        "cameraLenSize": "Φ64mm*60mm  200g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "Zeiss FE 35mm F2.8 ZA",
        "cameraLenSize": "Φ61.5mm*36.5mm  120g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "Sigma 30mm f/1.4 DC DN",
        "cameraLenSize": "Φ64.8mm*73.3mm  265g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "Sigma 35mm f1.4 DG HSM Art",
        "cameraLenSize": "Φ77mm*94mm  665g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "FE 55mm F1.8",
        "cameraLenSize": "Φ64mm*71mm  281g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "FE 50mm F2.8 MACRO",
        "cameraLenSize": "Φ71mm*71mm  236g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "FE 28-70mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ72.5mm*83mm 295g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "FE 85mm F1.4 GM",
        "cameraLenSize": "Φ89.5mm*107.5mm  820g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "E 18-135mm F3.5-5.6 OSS",
        "cameraLenSize": "Φ67.2mm*88mm  325g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Sony",
        "camera": "A6600",
        "cameraSize": "α6600 120×66.9×59mm,503g",
        "cameraLen": "E PZ 16-50mm f/3.5-5.6 OSS",
        "cameraLenSize": "Φ64.7mm*29.9mm  116g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH5S",
        "cameraSize": "GH5S  138.5×98.1×87.4mm  660g",
        "cameraLen": "LEICA DG SUMMILUX 15mm f/1.7 ASPH",
        "cameraLenSize": "Φ58mm*36mm*46mm  115.00g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Panasonic",
        "camera": "GH5S",
        "cameraSize": "GH5S  138.5×98.1×87.4mm  660g",
        "cameraLen": "LEICA DG SUMMILUX 25mm f/1.4 ASPH",
        "cameraLenSize": "Φ77.7mm*75mm 510g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH5S",
        "cameraSize": "GH5S  138.5×98.1×87.4mm  660g",
        "cameraLen": "LEICA DG MACRO 45mm f/2.8 OIS",
        "cameraLenSize": "Φ63mm*62.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Panasonic",
        "camera": "GH5S",
        "cameraSize": "GH5S  138.5×98.1×87.4mm  660g",
        "cameraLen": "LEICA DG Vario-Elmarit 8-18mm f/2.8-4.0 ASPH",
        "cameraLenSize": "Φ73.4mm*88mm  315g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH5S",
        "cameraSize": "GH5S  138.5×98.1×87.4mm  660g",
        "cameraLen": "LEICA DG Vario-Elmarit 12-60 \nf/2.8-4 Power OIS",
        "cameraLenSize": "Φ68mm*86mm  320g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH5S",
        "cameraSize": "GH5S  138.5×98.1×87.4mm  660g",
        "cameraLen": "LUMIX G X Vario 12-35mm f/2.8 II ASPH POWER OIS（H-HS12035GK I代）",
        "cameraLenSize": "Φ68mm*74mm  305g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH5S",
        "cameraSize": "GH5S  138.5×98.1×87.4mm  660g",
        "cameraLen": "M.ZUIKO DIGITAL ED 12mm f/2.0",
        "cameraLenSize": "Φ56mm*43mm  130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Panasonic",
        "camera": "GH5S",
        "cameraSize": "GH5S  138.5×98.1×87.4mm  660g",
        "cameraLen": "LUMIX G 14-140mm f/4-5.8 OIS",
        "cameraLenSize": "Φ70mm*84mm  460g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH5",
        "cameraSize": "GH5   138.5×98.1×87.4mm  725g",
        "cameraLen": "LEICA DG SUMMILUX 15mm f/1.7 ASPH",
        "cameraLenSize": "Φ58mm*36mm*46mm  115.00g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Panasonic",
        "camera": "GH5",
        "cameraSize": "GH5   138.5×98.1×87.4mm  725g",
        "cameraLen": "LEICA DG SUMMILUX 25mm f/1.4 ASPH",
        "cameraLenSize": "Φ77.7mm*75mm 510g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH5",
        "cameraSize": "GH5   138.5×98.1×87.4mm  725g",
        "cameraLen": "LEICA DG MACRO 45mm f/2.8 OIS",
        "cameraLenSize": "Φ63mm*62.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Panasonic",
        "camera": "GH5",
        "cameraSize": "GH5   138.5×98.1×87.4mm  725g",
        "cameraLen": "LEICA DG Vario-Elmarit 8-18mm f/2.8-4.0 ASPH",
        "cameraLenSize": "Φ73.4mm*88mm  315g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH5",
        "cameraSize": "GH5   138.5×98.1×87.4mm  725g",
        "cameraLen": "LEICA DG Vario-Elmarit 12-60 \nf/2.8-4 Power OIS",
        "cameraLenSize": "Φ68mm*86mm  320g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH5",
        "cameraSize": "GH5   138.5×98.1×87.4mm  725g",
        "cameraLen": "LUMIX G X Vario 12-35mm f/2.8 II ASPH POWER OIS（H-HS12035GK I代）",
        "cameraLenSize": "Φ68mm*74mm  305g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH5",
        "cameraSize": "GH5   138.5×98.1×87.4mm  725g",
        "cameraLen": "M.ZUIKO DIGITAL ED 12mm f/2.0",
        "cameraLenSize": "Φ56mm*43mm  130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Panasonic",
        "camera": "GH5",
        "cameraSize": "GH5   138.5×98.1×87.4mm  725g",
        "cameraLen": "LUMIX G 14-140mm f/4-5.8 OIS",
        "cameraLenSize": "Φ70mm*84mm  460g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "G9",
        "cameraSize": "G9    136.9×97.3×91.6mm  658g",
        "cameraLen": "LEICA DG SUMMILUX 15mm f/1.7 ASPH",
        "cameraLenSize": "Φ58mm*36mm*46mm  115.00g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Panasonic",
        "camera": "G9",
        "cameraSize": "G9    136.9×97.3×91.6mm  658g",
        "cameraLen": "LEICA DG SUMMILUX 25mm f/1.4 ASPH",
        "cameraLenSize": "Φ77.7mm*75mm 510g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "G9",
        "cameraSize": "G9    136.9×97.3×91.6mm  658g",
        "cameraLen": "LEICA DG MACRO 45mm f/2.8 OIS",
        "cameraLenSize": "Φ63mm*62.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Panasonic",
        "camera": "G9",
        "cameraSize": "G9    136.9×97.3×91.6mm  658g",
        "cameraLen": "LEICA DG Vario-Elmarit 8-18mm f/2.8-4.0 ASPH",
        "cameraLenSize": "Φ73.4mm*88mm  315g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "G9",
        "cameraSize": "G9    136.9×97.3×91.6mm  658g",
        "cameraLen": "LEICA DG Vario-Elmarit 12-60 \nf/2.8-4 Power OIS",
        "cameraLenSize": "Φ68mm*86mm  320g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "G9",
        "cameraSize": "G9    136.9×97.3×91.6mm  658g",
        "cameraLen": "LUMIX G X Vario 12-35mm f/2.8 II ASPH POWER OIS（H-HS12035GK I代）",
        "cameraLenSize": "Φ68mm*74mm  305g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "G9",
        "cameraSize": "G9    136.9×97.3×91.6mm  658g",
        "cameraLen": "M.ZUIKO DIGITAL ED 12mm f/2.0",
        "cameraLenSize": "Φ56mm*43mm  130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Panasonic",
        "camera": "G9",
        "cameraSize": "G9    136.9×97.3×91.6mm  658g",
        "cameraLen": "LUMIX G 14-140mm f/4-5.8 OIS",
        "cameraLenSize": "Φ70mm*84mm  460g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH4",
        "cameraSize": "GH4   93.4×83.9×132.9mm  560g",
        "cameraLen": "LEICA DG SUMMILUX 15mm f/1.7 ASPH",
        "cameraLenSize": "Φ58mm*36mm*46mm  115.00g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Panasonic",
        "camera": "GH4",
        "cameraSize": "GH4   93.4×83.9×132.9mm  560g",
        "cameraLen": "LEICA DG SUMMILUX 25mm f/1.4 ASPH",
        "cameraLenSize": "Φ77.7mm*75mm 510g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH4",
        "cameraSize": "GH4   93.4×83.9×132.9mm  560g",
        "cameraLen": "LEICA DG MACRO 45mm f/2.8 OIS",
        "cameraLenSize": "Φ63mm*62.5mm  225g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Panasonic",
        "camera": "GH4",
        "cameraSize": "GH4   93.4×83.9×132.9mm  560g",
        "cameraLen": "LEICA DG Vario-Elmarit 8-18mm f/2.8-4.0 ASPH",
        "cameraLenSize": "Φ73.4mm*88mm  315g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH4",
        "cameraSize": "GH4   93.4×83.9×132.9mm  560g",
        "cameraLen": "LEICA DG Vario-Elmarit 12-60 \nf/2.8-4 Power OIS",
        "cameraLenSize": "Φ68mm*86mm  320g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH4",
        "cameraSize": "GH4   93.4×83.9×132.9mm  560g",
        "cameraLen": "LUMIX G X Vario 12-35mm f/2.8 II ASPH POWER OIS（H-HS12035GK I代）",
        "cameraLenSize": "Φ68mm*74mm  305g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH4",
        "cameraSize": "GH4   93.4×83.9×132.9mm  560g",
        "cameraLen": "M.ZUIKO DIGITAL ED 12mm f/2.0",
        "cameraLenSize": "Φ56mm*43mm  130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Panasonic",
        "camera": "GH4",
        "cameraSize": "GH4   93.4×83.9×132.9mm  560g",
        "cameraLen": "LUMIX G 14-140mm f/4-5.8 OIS",
        "cameraLenSize": "Φ70mm*84mm  460g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "S1H",
        "cameraSize": "S1   151.0×114.2×110.4mm   1164g",
        "cameraLen": "LUMIX S PRO 24-70mm f/2.8",
        "cameraLenSize": "Φ90.9*140mm  935g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "S5",
        "cameraSize": "S5   132.6×97.1×81.9mm  714g",
        "cameraLen": "LUMIX S 24-105mm F4",
        "cameraLenSize": "Φ84mm*118mm  680g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "GH6",
        "cameraSize": "GH6  138.4*100.3*99.6mm  823g",
        "cameraLen": "LEICA DG Vario-Elmarit 12-60mm f/2.8-4 Power OIS",
        "cameraLenSize": "Φ68mm*86mm  320g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Panasonic",
        "camera": "S5 Ⅱ",
        "cameraSize": "S5II  102.3×134.3×90.1mm  740g",
        "cameraLen": "Lumix S 20-60mm f/3.5-5.6",
        "cameraLenSize": "Φ77.4×87.2mm  350g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z6",
        "cameraSize": "Z6  134×100.5×67.5mm  675g",
        "cameraLen": "NIKKOR Z 35mm f/1.8",
        "cameraLenSize": "Φ73mm*86mm  370g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z6",
        "cameraSize": "Z6  134×100.5×67.5mm  675g",
        "cameraLen": "18-140mm f/3.5-5.6G ED VR",
        "cameraLenSize": "Φ78mm*97mm  490g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z6",
        "cameraSize": "Z6  134×100.5×67.5mm  675g",
        "cameraLen": "NIKKOR Z 50mm f/1.8 S",
        "cameraLenSize": "Φ76mm*86.5mm 415g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z6",
        "cameraSize": "Z6  134×100.5×67.5mm  675g",
        "cameraLen": "NIKKOR Z 24-70mm f/4 S",
        "cameraLenSize": "Φ77.5mm*88.5mm 500g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z6",
        "cameraSize": "Z6  134×100.5×67.5mm  675g",
        "cameraLen": "NIKKOR Z 14-30mm f/4 S",
        "cameraLenSize": "Φ85mm*89mm  485g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z6",
        "cameraSize": "Z6  134×100.5×67.5mm  675g",
        "cameraLen": "NIKKOR Z 28mm f/2.8",
        "cameraLenSize": "Φ71.5mm*43mm  160g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z6",
        "cameraSize": "Z6  134×100.5×67.5mm  675g",
        "cameraLen": "NIKKOR Z macro 50mm f/2.8",
        "cameraLenSize": "Φ74.5mm*66mm  260g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z6 Ⅱ",
        "cameraSize": "Z6Ⅱ 134×100.5×69.5mm  615g",
        "cameraLen": "NIKKOR Z 35mm f/1.8",
        "cameraLenSize": "Φ73mm*86mm  370g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z6 Ⅱ",
        "cameraSize": "Z6Ⅱ 134×100.5×69.5mm  615g",
        "cameraLen": "18-140mm f/3.5-5.6G ED VR",
        "cameraLenSize": "Φ78mm*97mm  490g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z6 Ⅱ",
        "cameraSize": "Z6Ⅱ 134×100.5×69.5mm  615g",
        "cameraLen": "NIKKOR Z 50mm f/1.8 S",
        "cameraLenSize": "Φ76mm*86.5mm 415g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z6 Ⅱ",
        "cameraSize": "Z6Ⅱ 134×100.5×69.5mm  615g",
        "cameraLen": "NIKKOR Z 24-70mm f/4 S",
        "cameraLenSize": "Φ77.5mm*88.5mm 500g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z6 Ⅱ",
        "cameraSize": "Z6Ⅱ 134×100.5×69.5mm  615g",
        "cameraLen": "NIKKOR Z 14-30mm f/4 S",
        "cameraLenSize": "Φ85mm*89mm  485g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z6 Ⅱ",
        "cameraSize": "Z6Ⅱ 134×100.5×69.5mm  615g",
        "cameraLen": "NIKKOR Z 28mm f/2.8",
        "cameraLenSize": "Φ71.5mm*43mm  160g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z6 Ⅱ",
        "cameraSize": "Z6Ⅱ 134×100.5×69.5mm  615g",
        "cameraLen": "NIKKOR Z macro 50mm f/2.8",
        "cameraLenSize": "Φ74.5mm*66mm  260g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z7",
        "cameraSize": "Z7  134×100.5×67.5mm  675g",
        "cameraLen": "NIKKOR Z 35mm f/1.8",
        "cameraLenSize": "Φ73mm*86mm  370g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z7",
        "cameraSize": "Z7  134×100.5×67.5mm  675g",
        "cameraLen": "18-140mm f/3.5-5.6G ED VR",
        "cameraLenSize": "Φ78mm*97mm  490g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z7",
        "cameraSize": "Z7  134×100.5×67.5mm  675g",
        "cameraLen": "NIKKOR Z 50mm f/1.8 S",
        "cameraLenSize": "Φ76mm*86.5mm 415g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z7",
        "cameraSize": "Z7  134×100.5×67.5mm  675g",
        "cameraLen": "NIKKOR Z 24-70mm f/4 S",
        "cameraLenSize": "Φ77.5mm*88.5mm 500g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z7",
        "cameraSize": "Z7  134×100.5×67.5mm  675g",
        "cameraLen": "NIKKOR Z 14-30mm f/4 S",
        "cameraLenSize": "Φ85mm*89mm  485g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z7",
        "cameraSize": "Z7  134×100.5×67.5mm  675g",
        "cameraLen": "NIKKOR Z 28mm f/2.8",
        "cameraLenSize": "Φ71.5mm*43mm  160g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z7",
        "cameraSize": "Z7  134×100.5×67.5mm  675g",
        "cameraLen": "NIKKOR Z macro 50mm f/2.8",
        "cameraLenSize": "Φ74.5mm*66mm  260g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z7 Ⅱ",
        "cameraSize": "Z7 Ⅱ  134×100.5×67.5mm  705g",
        "cameraLen": "NIKKOR Z 35mm f/1.8",
        "cameraLenSize": "Φ73mm*86mm  370g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z7 Ⅱ",
        "cameraSize": "Z7 Ⅱ  134×100.5×67.5mm  705g",
        "cameraLen": "18-140mm f/3.5-5.6G ED VR",
        "cameraLenSize": "Φ78mm*97mm  490g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z7 Ⅱ",
        "cameraSize": "Z7 Ⅱ  134×100.5×67.5mm  705g",
        "cameraLen": "NIKKOR Z 50mm f/1.8 S",
        "cameraLenSize": "Φ76mm*86.5mm 415g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z7 Ⅱ",
        "cameraSize": "Z7 Ⅱ  134×100.5×67.5mm  705g",
        "cameraLen": "NIKKOR Z 24-70mm f/4 S",
        "cameraLenSize": "Φ77.5mm*88.5mm 500g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z7 Ⅱ",
        "cameraSize": "Z7 Ⅱ  134×100.5×67.5mm  705g",
        "cameraLen": "NIKKOR Z 14-30mm f/4 S",
        "cameraLenSize": "Φ85mm*89mm  485g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z7 Ⅱ",
        "cameraSize": "Z7 Ⅱ  134×100.5×67.5mm  705g",
        "cameraLen": "NIKKOR Z 28mm f/2.8",
        "cameraLenSize": "Φ71.5mm*43mm  160g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z7 Ⅱ",
        "cameraSize": "Z7 Ⅱ  134×100.5×67.5mm  705g",
        "cameraLen": "NIKKOR Z macro 50mm f/2.8",
        "cameraLenSize": "Φ74.5mm*66mm  260g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z50",
        "cameraSize": "Z50  126.5×93.5×60mm  450g",
        "cameraLen": "NIKKOR Z DX 16-50mm f/3.5-6.3 VR",
        "cameraLenSize": "Φ70mm*32mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser Required"
    },
    {
        "brand": "Nikon",
        "camera": "Zfc",
        "cameraSize": "Zfc  134.5×93.54×3.5mm  445g",
        "cameraLen": "NIKKOR Z DX 16-50mm f/3.5-6.3 VR",
        "cameraLenSize": "Φ70mm*32mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z9",
        "cameraSize": "Z9  149×149.5×90.5mm  1340g",
        "cameraLen": "NIKKOR Z 24-70mm f/2.8 S",
        "cameraLenSize": "Φ89mm*126mm  805g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "D7500",
        "cameraSize": "D7500 135.5×104×72.5mm 720g",
        "cameraLen": "NIKKOR 18-140mm f/3.5-5.6G ED VR",
        "cameraLenSize": "Φ78mm*97mm  490g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "The Long end lens requires lens holder"
    },
    {
        "brand": "Nikon",
        "camera": "D850",
        "cameraSize": "D850  146×124×78.5mm  1005g",
        "cameraLen": "AF-S NIKKOR 24-120mm f/4G ED VR",
        "cameraLenSize": "Φ84mm*103.5mm  710g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "In vertical installation, it is best to add a quick release plate in horizontal installation and install the lens holder"
    },
    {
        "brand": "Nikon",
        "camera": "Z5",
        "cameraSize": "Z5  134×100.5×69.5mm  675g",
        "cameraLen": "NIKKOR Z 50mm f/2.8",
        "cameraLenSize": "Φ74.5mm*66mm  260g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Nikon",
        "camera": "Z30",
        "cameraSize": "Z30  128 x 73.5 x 59.5mm  405g",
        "cameraLen": "NIKKOR Z DX 16-50mm f/3.5-6.3 VR",
        "cameraLenSize": "Φ70mm*32mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R",
        "cameraSize": "EOS R 135.8×98.3×84.4mm 660g",
        "cameraLen": "RF 35mm F1.8 MACRO IS STM",
        "cameraLenSize": "Φ74.4mm*62.8mm  305g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R",
        "cameraSize": "EOS R 135.8×98.3×84.4mm 660g",
        "cameraLen": "EF-S 18-200mm f/3.5-5.6 IS",
        "cameraLenSize": "Φ78.6mm*102mm  595g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R",
        "cameraSize": "EOS R 135.8×98.3×84.4mm 660g",
        "cameraLen": "EF 50mm f/1.4 DG HSM Art",
        "cameraLenSize": "Φ85mm*100mm  815g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R",
        "cameraSize": "EOS R 135.8×98.3×84.4mm 660g",
        "cameraLen": "EF 17-40mm f/4L USM",
        "cameraLenSize": "Φ83.5mm*96.8mm  475g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R",
        "cameraSize": "EOS R 135.8×98.3×84.4mm 660g",
        "cameraLen": "RF 50mm F1.2L USM",
        "cameraLenSize": "Φ89.8mm*108mm  950g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R",
        "cameraSize": "EOS R 135.8×98.3×84.4mm 660g",
        "cameraLen": "RF 28-70mm F2L USM",
        "cameraLenSize": "Φ103.8mm*139.8mm  1430g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R",
        "cameraSize": "EOS R 135.8×98.3×84.4mm 660g",
        "cameraLen": "RF 24-105mm F4L IS USM",
        "cameraLenSize": "Φ83.5mm*107.3mm 670g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R",
        "cameraSize": "EOS R 135.8×98.3×84.4mm 660g",
        "cameraLen": "RF 15-35mm F2.8 L IS USM",
        "cameraLenSize": "Φ88.5mm*126.8mm 840g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R",
        "cameraSize": "EOS R 135.8×98.3×84.4mm 660g",
        "cameraLen": "RF50mm F1.8 STM",
        "cameraLenSize": "Φ69.2mm*40.5mm  160g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R",
        "cameraSize": "EOS R 135.8×98.3×84.4mm 660g",
        "cameraLen": "RF85mm F2 MACRO IS STM",
        "cameraLenSize": "Φ78mm*90.5mm  500g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R",
        "cameraSize": "EOS R 135.8×98.3×84.4mm 660g",
        "cameraLen": "RF-S18-45mm F4.5-6.3 IS STM",
        "cameraLenSize": "Φ69mm*44.3mm  130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R",
        "cameraSize": "EOS R 135.8×98.3×84.4mm 660g",
        "cameraLen": "RF15-30mm F4.5-6.3 IS STM",
        "cameraLenSize": "Φ76.6mm*88.4mm  390g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser Required"
    },
    {
        "brand": "Canon",
        "camera": "EOS RP",
        "cameraSize": "EOS RP 132.5×85×70mm 485g",
        "cameraLen": "RF 35mm F1.8 MACRO IS STM",
        "cameraLenSize": "Φ74.4mm*62.8mm  305g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS RP",
        "cameraSize": "EOS RP 132.5×85×70mm 485g",
        "cameraLen": "EF-S 18-200mm f/3.5-5.6 IS",
        "cameraLenSize": "Φ78.6mm*102mm  595g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS RP",
        "cameraSize": "EOS RP 132.5×85×70mm 485g",
        "cameraLen": "EF 50mm f/1.4 DG HSM Art",
        "cameraLenSize": "Φ85mm*100mm  815g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS RP",
        "cameraSize": "EOS RP 132.5×85×70mm 485g",
        "cameraLen": "EF 17-40mm f/4L USM",
        "cameraLenSize": "Φ83.5mm*96.8mm  475g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS RP",
        "cameraSize": "EOS RP 132.5×85×70mm 485g",
        "cameraLen": "RF 50mm F1.2L USM",
        "cameraLenSize": "Φ89.8mm*108mm  950g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS RP",
        "cameraSize": "EOS RP 132.5×85×70mm 485g",
        "cameraLen": "RF 28-70mm F2L USM",
        "cameraLenSize": "Φ103.8mm*139.8mm  1430g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS RP",
        "cameraSize": "EOS RP 132.5×85×70mm 485g",
        "cameraLen": "RF 24-105mm F4L IS USM",
        "cameraLenSize": "Φ83.5mm*107.3mm 670g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS RP",
        "cameraSize": "EOS RP 132.5×85×70mm 485g",
        "cameraLen": "RF 15-35mm F2.8 L IS USM",
        "cameraLenSize": "Φ88.5mm*126.8mm 840g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS RP",
        "cameraSize": "EOS RP 132.5×85×70mm 485g",
        "cameraLen": "RF50mm F1.8 STM",
        "cameraLenSize": "Φ69.2mm*40.5mm  160g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS RP",
        "cameraSize": "EOS RP 132.5×85×70mm 485g",
        "cameraLen": "RF85mm F2 MACRO IS STM",
        "cameraLenSize": "Φ78mm*90.5mm  500g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS RP",
        "cameraSize": "EOS RP 132.5×85×70mm 485g",
        "cameraLen": "RF-S18-45mm F4.5-6.3 IS STM",
        "cameraLenSize": "Φ69mm*44.3mm  130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS RP",
        "cameraSize": "EOS RP 132.5×85×70mm 485g",
        "cameraLen": "RF15-30mm F4.5-6.3 IS STM",
        "cameraLenSize": "Φ76.6mm*88.4mm  390g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser Required"
    },
    {
        "brand": "Canon",
        "camera": "EOS R6",
        "cameraSize": "EOS R6 138.4×97.5×88.4mm 598g",
        "cameraLen": "RF 35mm F1.8 MACRO IS STM",
        "cameraLenSize": "Φ74.4mm*62.8mm  305g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R6",
        "cameraSize": "EOS R6 138.4×97.5×88.4mm 598g",
        "cameraLen": "EF-S 18-200mm f/3.5-5.6 IS",
        "cameraLenSize": "Φ78.6mm*102mm  595g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R6",
        "cameraSize": "EOS R6 138.4×97.5×88.4mm 598g",
        "cameraLen": "EF 50mm f/1.4 DG HSM Art",
        "cameraLenSize": "Φ85mm*100mm  815g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R6",
        "cameraSize": "EOS R6 138.4×97.5×88.4mm 598g",
        "cameraLen": "EF 17-40mm f/4L USM",
        "cameraLenSize": "Φ83.5mm*96.8mm  475g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R6",
        "cameraSize": "EOS R6 138.4×97.5×88.4mm 598g",
        "cameraLen": "RF 50mm F1.2L USM",
        "cameraLenSize": "Φ89.8mm*108mm  950g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R6",
        "cameraSize": "EOS R6 138.4×97.5×88.4mm 598g",
        "cameraLen": "RF 28-70mm F2L USM",
        "cameraLenSize": "Φ103.8mm*139.8mm  1430g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R6",
        "cameraSize": "EOS R6 138.4×97.5×88.4mm 598g",
        "cameraLen": "RF 24-105mm F4L IS USM",
        "cameraLenSize": "Φ83.5mm*107.3mm 670g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R6",
        "cameraSize": "EOS R6 138.4×97.5×88.4mm 598g",
        "cameraLen": "RF 15-35mm F2.8 L IS USM",
        "cameraLenSize": "Φ88.5mm*126.8mm 840g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R6",
        "cameraSize": "EOS R6 138.4×97.5×88.4mm 598g",
        "cameraLen": "RF50mm F1.8 STM",
        "cameraLenSize": "Φ69.2mm*40.5mm  160g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R6",
        "cameraSize": "EOS R6 138.4×97.5×88.4mm 598g",
        "cameraLen": "RF85mm F2 MACRO IS STM",
        "cameraLenSize": "Φ78mm*90.5mm  500g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R6",
        "cameraSize": "EOS R6 138.4×97.5×88.4mm 598g",
        "cameraLen": "RF-S18-45mm F4.5-6.3 IS STM",
        "cameraLenSize": "Φ69mm*44.3mm  130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R6",
        "cameraSize": "EOS R6 138.4×97.5×88.4mm 598g",
        "cameraLen": "RF15-30mm F4.5-6.3 IS STM",
        "cameraLenSize": "Φ76.6mm*88.4mm  390g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser Required"
    },
    {
        "brand": "Canon",
        "camera": "EOS 80D",
        "cameraSize": "EOS 80D  139×105.2×78.5mm  730g",
        "cameraLen": "EF-S 18-200mm f/3.5-5.6 IS",
        "cameraLenSize": "Φ78.6mm*102mm  595g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS 6D Mark Ⅱ",
        "cameraSize": "6D Mark II  144×110.5×74.8mm  765g",
        "cameraLen": "EF 24-70mm f/4L IS USM",
        "cameraLenSize": "Φ83.4mm*93mm   600g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS 6D",
        "cameraSize": "EOS 6D  144.5×110.5×71.2mm  750g",
        "cameraLen": "16-35mm f/2.8L II USM",
        "cameraLenSize": "Φ88.5mm*111.6mm  635g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS 6D",
        "cameraSize": "EOS 6D  144.5×110.5×71.2mm  750g",
        "cameraLen": "EF-S 18-200mm f/3.5-5.6 IS",
        "cameraLenSize": "Φ78.6mm*102mm  595g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS 6D",
        "cameraSize": "EOS 6D  144.5×110.5×71.2mm  750g",
        "cameraLen": "EF 24-105mm f/4L IS USM",
        "cameraLenSize": "Φ83.5mm*107mm 670g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS 200D Ⅱ",
        "cameraSize": "EOS 200D Ⅱ 122.4×92.6×69.8mm  456g",
        "cameraLen": "EF-S18-55mm f/4-5.6 IS STM",
        "cameraLenSize": "Φ66.5mm*61.8mm  215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS 5D Mark Ⅳ",
        "cameraSize": "5D Mark IV  150.7×116.4×75.9mm  890g",
        "cameraLen": "EF 24-105mm f/4L IS USM",
        "cameraLenSize": "Φ83.5mm*107mm 670g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS 5D Mark Ⅲ",
        "cameraSize": "5D MarkIII  152×116.4×76.4mm  950g",
        "cameraLen": "EF 24-105mm f/4L IS USM",
        "cameraLenSize": "Φ83.5mm*107mm 670g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS 5D Mark Ⅲ",
        "cameraSize": "5D MarkIII  152×116.4×76.4mm  950g",
        "cameraLen": "EF 24-105 mm f/4L IS II USM",
        "cameraLenSize": "Φ88.5mm *127.5mm 795g ",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS 5D Mark Ⅲ",
        "cameraSize": "5D MarkIII  152×116.4×76.4mm  950g",
        "cameraLen": "EF 24-70mm f/2.8L II USM",
        "cameraLenSize": "Φ88.5mm*113mm  805g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS 5D Mark Ⅲ",
        "cameraSize": "5D MarkIII  152×116.4×76.4mm  950g",
        "cameraLen": "16-35mm f/2.8L II USM",
        "cameraLenSize": "Φ88.5mm*111.6mm  635g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS 5DS R",
        "cameraSize": "5DS R 152×116.4×76.4mm  930g",
        "cameraLen": "EF 24-105mm f/4L IS USM",
        "cameraLenSize": "Φ83.5mm*107mm 670g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS 5DS R",
        "cameraSize": "5DS R 152×116.4×76.4mm  930g",
        "cameraLen": "EF 24-105 mm f/4L IS II USM",
        "cameraLenSize": "Φ88.5mm *127.5mm 795g ",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS 5DS R",
        "cameraSize": "5DS R 152×116.4×76.4mm  930g",
        "cameraLen": "EF 24-70mm f/2.8L II USM",
        "cameraLenSize": "Φ88.5mm*113mm  805g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS 5DS R",
        "cameraSize": "5DS R 152×116.4×76.4mm  930g",
        "cameraLen": "16-35mm f/2.8L II USM",
        "cameraLenSize": "Φ88.5mm*111.6mm  635g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS M50",
        "cameraSize": "M50  116.3×88.1×58.7mm  390g",
        "cameraLen": "EF-M 15-45mm F3.5-6.3 IS",
        "cameraLenSize": "Φ60.9mm*44.5mm   130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Canon",
        "camera": "EOS M50 Mark Ⅱ",
        "cameraSize": "EOS M50 Mark II  116.3×88.1×58.7mm  388g",
        "cameraLen": "EF-M 15-45mm f/3.5-6.3 IS STM",
        "cameraLenSize": "Φ60.9mm*44.5mm  130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "Powershot G7 X Mark Ⅲ",
        "cameraSize": "G7 X Mark III 105.0×60.9×41.4mm  304g",
        "cameraLen": "——",
        "cameraLenSize": "——",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS 850D",
        "cameraSize": "EOS 850D  131×102.6×76.2mm 515g",
        "cameraLen": "EF-S 18-55mm f/4-5.6 IS STM",
        "cameraLenSize": "Φ66.5mm*61.8mm  215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Canon",
        "camera": "EOS-1D X Mark Ⅲ",
        "cameraSize": "1D X Mark III  158×167.6×82.6mm 1250g",
        "cameraLen": "CANON EF 70-200mm f/2.8L IS III USM",
        "cameraLenSize": "Φ88.8mm*199mm   1480g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS 90D",
        "cameraSize": "EOS 90D 140.7×104.8×76.8mm  701g",
        "cameraLen": "EF-S 18-135mm f/3.5-5.6 IS USM",
        "cameraLenSize": "Φ77.4mm*96mm  515g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R3",
        "cameraSize": "EOS R3  150×142.6×87.2mm  1015g",
        "cameraLen": "RF28-70mm F2 L USM",
        "cameraLenSize": "Φ103.8mm*139.8mm 1430g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Lens holder is required. Because the camera is relatively heavy, vertical installation needs to be more careful, so that the quick release plate contact more camera, fixing screws as tight as possible, carefully leveling. Consider buying an extra quick mounting plate and using two support racks to support the camera"
    },
    {
        "brand": "Canon",
        "camera": "EOS R5C",
        "cameraSize": "EOS R5C 142×101×111mm 680g",
        "cameraLen": "RF14-35mm F4 L IS USM",
        "cameraLenSize": "Φ84.1mm*99.8mm 540g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser and lens holder are required,no need to remove the viewfinder's protector"
    },
    {
        "brand": "Canon",
        "camera": "EOS R5C",
        "cameraSize": "EOS R5C 142×101×111mm 680g",
        "cameraLen": "RF15-30mm F4.5-6.3 IS STM",
        "cameraLenSize": "Φ76.6mm*88.4mm  390g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R5",
        "cameraSize": "EOS R5  138.5×97.5×88mm  738g",
        "cameraLen": "RF14-35mm F4 L IS USM",
        "cameraLenSize": "Φ84.1mm*99.8mm 540g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser and lens holder are required,no need to remove the viewfinder's protector"
    },
    {
        "brand": "Canon",
        "camera": "EOS R5",
        "cameraSize": "EOS R5  138.5×97.5×88mm  738g",
        "cameraLen": "RF15-30mm F4.5-6.3 IS STM",
        "cameraLenSize": "Φ76.6mm*88.4mm  390g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS M6 Mark Ⅱ",
        "cameraSize": "EOS M6 Mark II  119.6×70×49.2mm  408g",
        "cameraLen": "EF-M 15-45mm f/3.5-6.3 IS STM",
        "cameraLenSize": "Φ60.9mm*44.5mm  130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R7",
        "cameraSize": "EOS R7  132×90.4×91.7mm  612g",
        "cameraLen": "RF-S18-150mm F3.5-6.3 IS STM",
        "cameraLenSize": "Φ69mm*84.5mm  310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R7",
        "cameraSize": "EOS R7  132×90.4×91.7mm  612g",
        "cameraLen": "RF35mm F1.8 MACRO IS STM",
        "cameraLenSize": "Φ74.4mm*62.8mm 305g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required"
    },
    {
        "brand": "Canon",
        "camera": "EOS R7",
        "cameraSize": "EOS R7  132×90.4×91.7mm  612g",
        "cameraLen": "RF-S18-45mm F4.5-6.3 IS STM",
        "cameraLenSize": "Φ69mm*44.3  130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R7",
        "cameraSize": "EOS R7  132×90.4×91.7mm  612g",
        "cameraLen": "RF 14-35mm f/4 L IS USM",
        "cameraLenSize": "Φ84.1mm*99.8mm  540g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required"
    },
    {
        "brand": "Canon",
        "camera": "EOS R10",
        "cameraSize": "EOS R10  122.5×87.8×83.4mm  429g",
        "cameraLen": "RF-S18-150mm F3.5-6.3 IS STM",
        "cameraLenSize": "Φ69mm*84.5mm  310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R10",
        "cameraSize": "EOS R10  122.5×87.8×83.4mm  429g",
        "cameraLen": "RF35mm F1.8 MACRO IS STM",
        "cameraLenSize": "Φ74.4mm*62.8mm 305g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required"
    },
    {
        "brand": "Canon",
        "camera": "EOS R10",
        "cameraSize": "EOS R10  122.5×87.8×83.4mm  429g",
        "cameraLen": "RF-S18-45mm F4.5-6.3 IS STM",
        "cameraLenSize": "Φ69mm*44.3  130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R10",
        "cameraSize": "EOS R10  122.5×87.8×83.4mm  429g",
        "cameraLen": "RF 14-35mm f/4 L IS USM",
        "cameraLenSize": "Φ84.1mm*99.8mm  540g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required"
    },
    {
        "brand": "Canon",
        "camera": "EOS R10",
        "cameraSize": "EOS R10  122.5×87.8×83.4mm  429g",
        "cameraLen": "RF85mm F2 MACRO IS STM",
        "cameraLenSize": "Φ78mm*90.5mm  500g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required"
    },
    {
        "brand": "Canon",
        "camera": "EOS R8",
        "cameraSize": "EOS R8  132.5×86.1×70mm  461g",
        "cameraLen": "RF24-50mm F4.5-6.3 IS STM",
        "cameraLenSize": "Φ69.6mm*58mm  210g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R50",
        "cameraSize": "EOS R50  116.3×85.5×68.8mm  376g",
        "cameraLen": "RF-S18-45mm F4.5-6.3 IS STM",
        "cameraLenSize": "Φ69mm*44.3mm  130g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Canon",
        "camera": "EOS R6 Mark Ⅱ",
        "cameraSize": "EOS R6 Mark II  138.4×98.4×88.4mm 670g",
        "cameraLen": "RF24mm F1.8 MACRO IS STM",
        "cameraLenSize": "Φ74.4×63.1mm  270g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T3",
        "cameraSize": "X-T3  132.5×92.8×58.8mm  539g",
        "cameraLen": "XF 16mm 1:1.4 R WR",
        "cameraLenSize": "Φ73mm*73mm  375g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T3",
        "cameraSize": "X-T3  132.5×92.8×58.8mm  539g",
        "cameraLen": "XF 23mm 1:1.4 R",
        "cameraLenSize": "Φ72mm*63mm  300g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T3",
        "cameraSize": "X-T3  132.5×92.8×58.8mm  539g",
        "cameraLen": "XF 35mm 1:1.4",
        "cameraLenSize": "Φ65mm*54.9mm  187g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T3",
        "cameraSize": "X-T3  132.5×92.8×58.8mm  539g",
        "cameraLen": "XF 10-24mm f/4.0 R OIS",
        "cameraLenSize": "Φ78mm*87mm  410g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T3",
        "cameraSize": "X-T3  132.5×92.8×58.8mm  539g",
        "cameraLen": "XF 16-55mm 1：2.8 R LM WR",
        "cameraLenSize": "Φ83.3mm*106.0mm  655g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T3",
        "cameraSize": "X-T3  132.5×92.8×58.8mm  539g",
        "cameraLen": "XF 18-55mm 1:2.8-4 R OIS",
        "cameraLenSize": "Φ65mm*70.4mm  310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T3",
        "cameraSize": "X-T3  132.5×92.8×58.8mm  539g",
        "cameraLen": "XF 18-135mm f/3.5-5.6 R LM OIS WR",
        "cameraLenSize": "Φ76mm*98mm  490g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T4",
        "cameraSize": "X-T4  134.6×92.8×63.8mm  607g",
        "cameraLen": "XF 16mm 1:1.4 R WR",
        "cameraLenSize": "Φ73mm*73mm  375g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T4",
        "cameraSize": "X-T4  134.6×92.8×63.8mm  607g",
        "cameraLen": "XF 23mm 1:1.4 R",
        "cameraLenSize": "Φ72mm*63mm  300g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T4",
        "cameraSize": "X-T4  134.6×92.8×63.8mm  607g",
        "cameraLen": "XF 35mm 1:1.4",
        "cameraLenSize": "Φ65mm*54.9mm  187g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T4",
        "cameraSize": "X-T4  134.6×92.8×63.8mm  607g",
        "cameraLen": "XF 10-24mm f/4.0 R OIS",
        "cameraLenSize": "Φ78mm*87mm  410g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T4",
        "cameraSize": "X-T4  134.6×92.8×63.8mm  607g",
        "cameraLen": "XF 16-55mm 1：2.8 R LM WR",
        "cameraLenSize": "Φ83.3mm*106.0mm  655g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T4",
        "cameraSize": "X-T4  134.6×92.8×63.8mm  607g",
        "cameraLen": "XF 18-55mm 1:2.8-4 R OIS",
        "cameraLenSize": "Φ65mm*70.4mm  310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T4",
        "cameraSize": "X-T4  134.6×92.8×63.8mm  607g",
        "cameraLen": "XF 18-135mm f/3.5-5.6 R LM OIS WR",
        "cameraLenSize": "Φ76mm*98mm  490g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H1",
        "cameraSize": "X-H1  139.8×97.3×85.5mm  673g",
        "cameraLen": "XF 16mm 1:1.4 R WR",
        "cameraLenSize": "Φ73mm*73mm  375g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H1",
        "cameraSize": "X-H1  139.8×97.3×85.5mm  673g",
        "cameraLen": "XF 23mm 1:1.4 R",
        "cameraLenSize": "Φ72mm*63mm  300g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H1",
        "cameraSize": "X-H1  139.8×97.3×85.5mm  673g",
        "cameraLen": "XF 35mm 1:1.4",
        "cameraLenSize": "Φ65mm*54.9mm  187g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H1",
        "cameraSize": "X-H1  139.8×97.3×85.5mm  673g",
        "cameraLen": "XF 10-24mm f/4.0 R OIS",
        "cameraLenSize": "Φ78mm*87mm  410g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H1",
        "cameraSize": "X-H1  139.8×97.3×85.5mm  673g",
        "cameraLen": "XF 16-55mm 1：2.8 R LM WR",
        "cameraLenSize": "Φ83.3mm*106.0mm 655g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H1",
        "cameraSize": "X-H1  139.8×97.3×85.5mm  673g",
        "cameraLen": "XF 18-55mm 1:2.8-4 R OIS",
        "cameraLenSize": "Φ65mm*70.4mm  310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H1",
        "cameraSize": "X-H1  139.8×97.3×85.5mm  673g",
        "cameraLen": "XF 18-135mm f/3.5-5.6 R LM OIS WR",
        "cameraLenSize": "Φ76mm*98mm  490g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-S10",
        "cameraSize": "X-S10 126×85.1×65.4mm  465g",
        "cameraLen": "XC 15-45mm f/3.5-5.6 OIS PZ",
        "cameraLenSize": "Φ62.6mm*65.2mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser Required"
    },
    {
        "brand": "Fujifilm",
        "camera": "X-A5\nX-A7",
        "cameraSize": "X-A5  116.9×67.7×40.4mm 361g\nX-A7  119×67.7×41.1mm  320g",
        "cameraLen": "XC 15-45mm f/3.5-5.6 OIS PZ",
        "cameraLenSize": "Φ62.6mm*65.2mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser Required"
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30 Ⅱ",
        "cameraSize": "X-T30 II  118×83×47mm  383g",
        "cameraLen": "XC 15-45mm f/3.5-5.6 OIS PZ",
        "cameraLenSize": "Φ62.6mm*65.2mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-E3",
        "cameraSize": "X-E3 121.3×42.7×73.9mm 337g",
        "cameraLen": "XF18-55mm F2.8-4 R LM OI",
        "cameraLenSize": "Φ65mm*70.4mm  310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X100V",
        "cameraSize": "X100V  128×74.8×53.3mm  478g",
        "cameraLen": "Kit Lens",
        "cameraLenSize": "——",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "GFX 100S",
        "cameraSize": "GFX 100S  150×104.2×87.2mm  900g",
        "cameraLen": "GF 32-64mm f/4R LM WR",
        "cameraLenSize": "Φ92.6mm*145.5mm  875g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is Required"
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T20",
        "cameraSize": "X-T20  118.4×82.8×41.4mm  383g",
        "cameraLen": "XF 16mm 1:1.4 R WR",
        "cameraLenSize": "Φ73mm*73mm  375g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T20",
        "cameraSize": "X-T20  118.4×82.8×41.4mm  383g",
        "cameraLen": "XF 23mm 1:1.4 R",
        "cameraLenSize": "Φ72mm*63mm  300g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T20",
        "cameraSize": "X-T20  118.4×82.8×41.4mm  383g",
        "cameraLen": "XF 35mm 1:1.4",
        "cameraLenSize": "Φ65mm*54.9mm  187g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T20",
        "cameraSize": "X-T20  118.4×82.8×41.4mm  383g",
        "cameraLen": "XF 10-24mm f/4.0 R OIS",
        "cameraLenSize": "Φ78mm*87mm  410g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T20",
        "cameraSize": "X-T20  118.4×82.8×41.4mm  383g",
        "cameraLen": "XC 16-50mm f/3.5-5.6 OIS",
        "cameraLenSize": "Φ62.6mm*65.2mm   195g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T20",
        "cameraSize": "X-T20  118.4×82.8×41.4mm  383g",
        "cameraLen": "XF 16-55mm 1：2.8 R LM WR",
        "cameraLenSize": "Φ83.3mm x 106.0mm  655g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T20",
        "cameraSize": "X-T20  118.4×82.8×41.4mm  383g",
        "cameraLen": "XF 18-55mm 1:2.8-4 R OIS",
        "cameraLenSize": "Φ65mm*70.4mm  310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T20",
        "cameraSize": "X-T20  118.4×82.8×41.4mm  383g",
        "cameraLen": "XF 18-135mm f/3.5-5.6 R LM OIS WR",
        "cameraLenSize": "Φ76mm*98mm  490g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T20",
        "cameraSize": "X-T20  118.4×82.8×41.4mm  383g",
        "cameraLen": "XC 15-45mm 1:3.5-5.6 OIS PZ",
        "cameraLenSize": "Φ62.6mm*65.2mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30",
        "cameraSize": "X-T30  118.4×82.8×46.8mm  383g",
        "cameraLen": "XF 16mm 1:1.4 R WR",
        "cameraLenSize": "Φ73mm*73mm  375g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30",
        "cameraSize": "X-T30  118.4×82.8×46.8mm  383g",
        "cameraLen": "XF 23mm 1:1.4 R",
        "cameraLenSize": "Φ72mm*63mm  300g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30",
        "cameraSize": "X-T30  118.4×82.8×46.8mm  383g",
        "cameraLen": "XF 35mm 1:1.4",
        "cameraLenSize": "Φ65mm*54.9mm  187g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30",
        "cameraSize": "X-T30  118.4×82.8×46.8mm  383g",
        "cameraLen": "XF 10-24mm f/4.0 R OIS",
        "cameraLenSize": "Φ78mm*87mm  410g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30",
        "cameraSize": "X-T30  118.4×82.8×46.8mm  383g",
        "cameraLen": "XC 16-50mm f/3.5-5.6 OIS",
        "cameraLenSize": "Φ62.6mm*65.2mm   195g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30",
        "cameraSize": "X-T30  118.4×82.8×46.8mm  383g",
        "cameraLen": "XF 16-55mm 1：2.8 R LM WR",
        "cameraLenSize": "Φ83.3mm x 106.0mm  655g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30",
        "cameraSize": "X-T30  118.4×82.8×46.8mm  383g",
        "cameraLen": "XF 18-55mm 1:2.8-4 R OIS",
        "cameraLenSize": "Φ65mm*70.4mm  310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30",
        "cameraSize": "X-T30  118.4×82.8×46.8mm  383g",
        "cameraLen": "XF 18-135mm f/3.5-5.6 R LM OIS WR",
        "cameraLenSize": "Φ76mm*98mm  490g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T30",
        "cameraSize": "X-T30  118.4×82.8×46.8mm  383g",
        "cameraLen": "XC 15-45mm 1:3.5-5.6 OIS PZ",
        "cameraLenSize": "Φ62.6mm*65.2mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T100",
        "cameraSize": "X-T100  121.0×83.0×47.4mm  448g",
        "cameraLen": "XF 16mm 1:1.4 R WR",
        "cameraLenSize": "Φ73mm*73mm  375g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T100",
        "cameraSize": "X-T100  121.0×83.0×47.4mm  448g",
        "cameraLen": "XF 23mm 1:1.4 R",
        "cameraLenSize": "Φ72mm*63mm  300g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T100",
        "cameraSize": "X-T100  121.0×83.0×47.4mm  448g",
        "cameraLen": "XF 35mm 1:1.4",
        "cameraLenSize": "Φ65mm*54.9mm  187g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T100",
        "cameraSize": "X-T100  121.0×83.0×47.4mm  448g",
        "cameraLen": "XF 10-24mm f/4.0 R OIS",
        "cameraLenSize": "Φ78mm*87mm  410g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T100",
        "cameraSize": "X-T100  121.0×83.0×47.4mm  448g",
        "cameraLen": "XC 16-50mm f/3.5-5.6 OIS",
        "cameraLenSize": "Φ62.6mm*65.2mm   195g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T100",
        "cameraSize": "X-T100  121.0×83.0×47.4mm  448g",
        "cameraLen": "XF 16-55mm 1：2.8 R LM WR",
        "cameraLenSize": "Φ83.3mm x 106.0mm  655g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T100",
        "cameraSize": "X-T100  121.0×83.0×47.4mm  448g",
        "cameraLen": "XF 18-55mm 1:2.8-4 R OIS",
        "cameraLenSize": "Φ65mm*70.4mm  310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T100",
        "cameraSize": "X-T100  121.0×83.0×47.4mm  448g",
        "cameraLen": "XF 18-135mm f/3.5-5.6 R LM OIS WR",
        "cameraLenSize": "Φ76mm*98mm  490g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T100",
        "cameraSize": "X-T100  121.0×83.0×47.4mm  448g",
        "cameraLen": "XC 15-45mm 1:3.5-5.6 OIS PZ",
        "cameraLenSize": "Φ62.6mm*65.2mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T200",
        "cameraSize": "X-T200  121.0×83.7×55.1mm  370g",
        "cameraLen": "XF 16mm 1:1.4 R WR",
        "cameraLenSize": "Φ73mm*73mm  375g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T200",
        "cameraSize": "X-T200  121.0×83.7×55.1mm  370g",
        "cameraLen": "XF 23mm 1:1.4 R",
        "cameraLenSize": "Φ72mm*63mm  300g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T200",
        "cameraSize": "X-T200  121.0×83.7×55.1mm  370g",
        "cameraLen": "XF 35mm 1:1.4",
        "cameraLenSize": "Φ65mm*54.9mm  187g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T200",
        "cameraSize": "X-T200  121.0×83.7×55.1mm  370g",
        "cameraLen": "XF 10-24mm f/4.0 R OIS",
        "cameraLenSize": "Φ78mm*87mm  410g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T200",
        "cameraSize": "X-T200  121.0×83.7×55.1mm  370g",
        "cameraLen": "XC 16-50mm f/3.5-5.6 OIS",
        "cameraLenSize": "Φ62.6mm*65.2mm   195g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T200",
        "cameraSize": "X-T200  121.0×83.7×55.1mm  370g",
        "cameraLen": "XF 16-55mm 1：2.8 R LM WR",
        "cameraLenSize": "Φ83.3mm x 106.0mm  655g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T200",
        "cameraSize": "X-T200  121.0×83.7×55.1mm  370g",
        "cameraLen": "XF 18-55mm 1:2.8-4 R OIS",
        "cameraLenSize": "Φ65mm*70.4mm  310g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T200",
        "cameraSize": "X-T200  121.0×83.7×55.1mm  370g",
        "cameraLen": "XF 18-135mm f/3.5-5.6 R LM OIS WR",
        "cameraLenSize": "Φ76mm*98mm  490g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T200",
        "cameraSize": "X-T200  121.0×83.7×55.1mm  370g",
        "cameraLen": "XC 15-45mm 1:3.5-5.6 OIS PZ",
        "cameraLenSize": "Φ62.6mm*65.2mm  135g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser is required to help balancing the gimbal."
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H2S",
        "cameraSize": "X-H2S  136.3×92.9×84.6mm  660g",
        "cameraLen": "XF90mmF2 R LM WR",
        "cameraLenSize": "Φ 75.0mm*105mm  540g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "Fujifilm",
        "camera": "X-H2",
        "cameraSize": "X-H2  136.3×92.9×84.6mm  660g",
        "cameraLen": "XF 16mm f/1.4R WR",
        "cameraLenSize": "Φ73.4mm*73.0mm  375g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser Required"
    },
    {
        "brand": "Fujifilm",
        "camera": "X-T5",
        "cameraSize": "X-T5  129.5×91×63.8mm  557g",
        "cameraLen": "XF 8-16mm f/2.8 R LM WR",
        "cameraLenSize": "Φ88*121.5mm  808g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser Required"
    },
    {
        "brand": "Fujifilm",
        "camera": "X-S20",
        "cameraSize": "X-S20  127.7x85.1x65.4mm  491g",
        "cameraLen": "XF18mmF1.4 R LM WR",
        "cameraLenSize": "Φ68.8*75.6mm  370g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "SIGMA",
        "camera": "FP",
        "cameraSize": "FP 112.6×69.9×45.3mm  370g",
        "cameraLen": "pansonic LUMIX S PRO 50mm F1.4",
        "cameraLenSize": "Φ90mm*130mm  955g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": "Camera Riser Required"
    },
    {
        "brand": "SIGMA",
        "camera": "FP",
        "cameraSize": "FP 112.6×69.9×45.3mm  370g",
        "cameraLen": "SIGMA 45mm f/2.8 DG DN",
        "cameraLenSize": "Φ64mm*46.2mm  215g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "BMPCC",
        "camera": "BMPCC 6K",
        "cameraSize": "MPCC  177.8*101.6*96.52mm  898g",
        "cameraLen": "CANON EF 16-35mm f2.8L II USM",
        "cameraLenSize": "Φ88.5mm*111.6mm  640g",
        "mountingStatue": "Camera + Lens+\ncage+battery",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    },
    {
        "brand": "BMPCC",
        "camera": "BMPCC 4k",
        "cameraSize": "179.8*122.9*112mm  1238.3g",
        "cameraLen": "Olympus M.ZUIKO DIGITAL ED 12-40mm f/2.8",
        "cameraLenSize": "Φ70mm*84mm  382g",
        "mountingStatue": "Camera + Lens",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "√",
        "verticalLong": "√",
        "installationRemark": ""
    },
    {
        "brand": "BMPCC",
        "camera": "BMPCC 4k",
        "cameraSize": "179.8*122.9*112mm  1238.3g",
        "cameraLen": "Olympus M.ZUIKO DIGITAL ED 12-40mm f/2.8",
        "cameraLenSize": "Φ70mm*84mm  382g",
        "mountingStatue": "Focus motor +cage",
        "horizontallyShort": "√",
        "horizontallyLong": "√",
        "verticalShort": "×",
        "verticalLong": "×",
        "installationRemark": ""
    }
]
export default data